window.dataLayer = window.dataLayer || [];
var analytics = analytics || {};
analytics.eventConfig = [];

/*jshint sub:true*/
$(function (window, $) {
    var ga = (function () { //IIFE - pattern

        $(window).on('load', function () {
            $(analytics.eventConfig).each(function (index, component) {

                if ($(component.target).length > 0 || component.target === ".component.a14-resource-list") {
                    $.each(component.events, function (i, eventsObj) {
                        setTimeout(function () {
                            attachEventHandler(eventsObj, component.target + " " + eventsObj.eventTarget);
                        }, 1000);
                    });
                }
            });

            bindAnalyticsEvents();
        });

    })();
    window.googleAnalytics = ga;
}(window, window.jQuery));

function blockEventCapture(tagValue, url) {
    var analyticsflag = document.querySelector('meta[name="gdpr_googleanalytics"]');
    if (analyticsflag != null && (analyticsflag.content == undefined || analyticsflag.content == 'True')) {
        window.dataLayer.push(tagValue);
    }
    if (url) {
        window.location.href = url;
    }
}
function attachEventHandler(eventsObj, selector, fromAngular, eventTarget, buttonElementText, angularComponentname, filters) {
    if (fromAngular) {
        if (!analytics) {
            setTimeout(function () {
                attachEventHandler(eventsObj, selector, fromAngular, eventTarget);
            }, 1000);
            return;
        }
        var tempEventObj = {};
        $(analytics.eventConfig).each(function (index, component) {
            if (component.target === eventsObj) {

                for (var i = 0; i < component.events.length; i++) {
                    if (component.events[i].eventTarget === selector) {
                        tempEventObj = JSON.parse(JSON.stringify(component.events[i]));
                    }
                }
            }
        });
        if (selector == "allow-location" || selector == "block-location") {
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "backdropClick") {
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "gallerybackdropClick") {
            var galleryTags = parseDynamicValues($(event.target).closest('.gallery-video-modal, .gallery-image-modal'), tempEventObj, null, buttonElementText, angularComponentname);
            tempEventObj.tags.parentTitle = galleryTags.parentTitle;
            tempEventObj.tags.parentName = galleryTags.parentName;
            tempEventObj.tags.titleText = galleryTags.titleText;
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "sharethispageemailbackdropclick") {
            var shareTags = parseDynamicValues($(event.target).closest('#Sharethispage'), tempEventObj, null, buttonElementText, angularComponentname);
            tempEventObj.tags.parentName = shareTags.parentName;
            tempEventObj.tags.titleText = shareTags.titleText;
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "SearchBoxSearchLocator") {
            var tagsFetchedLocator = parseDynamicValues($('#searchContainer input'), tempEventObj, null, buttonElementText, angularComponentname);
            tempEventObj.tags.searchTerm = tagsFetchedLocator.searchTerm;
            tempEventObj.tags.searchType = tagsFetchedLocator.searchType;
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "onCategoryIconClick") {
            tempEventObj.tags.elementText = $("[data-icons-title] .activeIcon").text().trim();
            tempEventObj.tags.titleText = $("[data-icons-title]").attr("data-icons-title").trim();
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "searchIconClick") {
            var resultsFetchedForLocator = parseDynamicValues($(eventTarget), tempEventObj, null, buttonElementText, angularComponentname);
            if ($("#searchInput").length > 0) {
                tempEventObj.tags.searchTerm = $("#searchInput")[0]?.value?.toLowerCase() ?? "";
            }
            else if ($("#siteIdInput").length > 0) {
                tempEventObj.tags.searchTerm = $("#siteIdInput").val()?.toLowerCase() ?? "";
            }
            tempEventObj.tags.destinationUrl = buttonElementText;
            tempEventObj.tags.searchType = resultsFetchedForLocator.searchType;
            tempEventObj.tags.titleText = resultsFetchedForLocator.titleText;
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "triggerOnNavigateToRecommendation") {
            tempEventObj.tags.destinationUrl = eventTarget;
            if ($(document.querySelectorAll(".row.form-inner:not(.categoriesDynamicSelect) dynamic-select:nth-last-child(1) .noTriggerAnalyticsEvent select")[0]).children('option:selected').length) {
                tempEventObj.tags.elementText = $(document.querySelectorAll(".row.form-inner:not(.categoriesDynamicSelect) dynamic-select:nth-last-child(1) .noTriggerAnalyticsEvent select")[0]).children('option:selected').text().trim().toLowerCase();
            } else {
                tempEventObj.tags.elementText = $(".selector-search.search-box .btn-primary").text().trim().toLowerCase();
            }
            tempEventObj.tags.searchFacets = getFacetVal();
            blockEventCapture(tempEventObj.tags, tempEventObj.tags.destinationUrl);
            return;
        } else if (selector == "triggerNavigateToRecommendationAutoSuggest") {
            tempEventObj.tags.destinationUrl = eventTarget;
            tempEventObj.tags.elementText = $("#dropdownMenuButton").val().trim().toLowerCase();
            tempEventObj.tags.searchFacets = getFacetVal();
            blockEventCapture(tempEventObj.tags, tempEventObj.tags.destinationUrl);
            return;
        } else if (selector == "onInvoiceClick") {
            var resultsFetched = parseDynamicValues($(eventTarget), tempEventObj, null, buttonElementText, angularComponentname);
            tempEventObj.tags.elementText = resultsFetched.elementText;
            tempEventObj.tags.destinationUrl = resultsFetched.destinationUrl;
            tempEventObj.tags.searchSubType = resultsFetched.searchSubType;
            tempEventObj.tags.searchTerm = resultsFetched.searchTerm;
            tempEventObj.tags.searchType = resultsFetched.searchType;
            tempEventObj.tags.titleText = $(eventTarget).attr("data-location-name").toLowerCase();
            blockEventCapture(tempEventObj.tags);
            return;
        } 
        else if (selector == "onSuccessfulFormSubmission") {
            tempEventObj.tags.elementText = $(".form-submit").val().toLowerCase();
            tempEventObj.tags.formName = $("[data-panel-id=4]").find(".panel-heading .panel-title a:not(.collapsed)").children()[1].innerText.toLowerCase();
            tempEventObj.tags.formTitle = $("[data-panel-id=4]").find(".panel-heading .panel-title a:not(.collapsed)").children()[1].innerText.toLowerCase();
            tempEventObj.tags.parentTitle = "";
            tempEventObj.tags.parentName = "";
            blockEventCapture(tempEventObj.tags);
            return;
        }
        else if (selector == "onProceedToNextForm") {
            tempEventObj.tags.elementText = fromAngular.text;
            tempEventObj.tags.formName = fromAngular.formName.toLowerCase();
            tempEventObj.tags.formTitle = fromAngular.formName.toLowerCase();
            tempEventObj.tags.formSteps = fromAngular.formSteps.toLowerCase();
            tempEventObj.tags.eventType = fromAngular.eventType.toLowerCase();
            tempEventObj.tags.parentTitle = "";
            tempEventObj.tags.parentName = "";
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "onFormUnsuccessfulSubmit") {
            tempEventObj.tags.elementText = $(".form-submit").val().toLowerCase();
            tempEventObj.tags.formName = $("[data-panel-id=4]").find(".panel-heading .panel-title a:not(.collapsed)").children()[1].innerText.toLowerCase();
            tempEventObj.tags.formTitle = $("[data-panel-id=4]").find(".panel-heading .panel-title a:not(.collapsed)").children()[1].innerText.toLowerCase();
            tempEventObj.tags.parentTitle = "";
            tempEventObj.tags.parentName = "";
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "onFormInitiation") {
            tempEventObj.tags.elementText = fromAngular.text.toLowerCase();
            tempEventObj.tags.formName = fromAngular.formName.toLowerCase();
            tempEventObj.tags.formTitle = fromAngular.formName.toLowerCase();
            tempEventObj.tags.parentTitle = "";
            tempEventObj.tags.parentName = "";
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "triggerOnChangeEventTypeAhead") {
            tempEventObj.tags.elementText = angularComponentname.elementText.toLowerCase();
            tempEventObj.tags.titleText = angularComponentname.titleText.toLowerCase();
            tempEventObj.tags.elementType = angularComponentname.elementType.toLowerCase();
            tempEventObj.tags.event = angularComponentname.event.toLowerCase();
            tempEventObj.tags.eventType = angularComponentname.eventType.toLowerCase();
            blockEventCapture(tempEventObj.tags);
            return;
        } else if (selector == "onResultsFetched" && eventTarget) {
            setTimeout(function () {
                var onResultsFetchedTag = parseDynamicValues($(eventTarget), tempEventObj, null, buttonElementText, angularComponentname);
                var numberOfResults = 0;

                if ($(".result-wrapper").length) {
                    numberOfResults = $(".result-wrapper").length;
                } else if ($("tr td:nth-child(2).product-list-description").length) {
                    numberOfResults = $("tr td:nth-child(2).product-list-description").length;
                } else if ($(".product-list-description").length) {
                    numberOfResults = $(".product-list-description").length;
                }
                onResultsFetchedTag.searchResults = numberOfResults;
                if (onResultsFetchedTag.searchType == "aviation" || onResultsFetchedTag.searchType === "marine") {
                    onResultsFetchedTag.searchResults = fromAngular.numberOfResults;
                }

                onResultsFetchedTag.searchFacets = "";
                var checkboxes = $(".amenities-row input[type='checkbox'] ~ .checked");
                var checkboxesNew = angularComponentname === 'newlocator' ? filters : [];
                for (var i = 0; i < checkboxes.length; i++) {
                    if (i === 0) {
                        onResultsFetchedTag.searchFacets += "Amenities:";
                    }
                    if (i < checkboxes.length - 1) {
                        onResultsFetchedTag.searchFacets += $(checkboxes[i]).text() + ",";
                    }
                    else {
                        onResultsFetchedTag.searchFacets += $(checkboxes[i]).text();
                    }
                }
                if (checkboxesNew && angularComponentname === 'newlocator') {
                    for (var j = 0; j < checkboxesNew.length; j++) {
                        if (checkboxesNew[j].isFilter) {
                            if (checkboxesNew[j].Key) {
                                onResultsFetchedTag.searchFacets += checkboxesNew[j].Label + ":";
                            }
                            var counter = 0;
                            for (var k = 0; k < checkboxesNew[j].StringToObj.length; k++) {
                                if (checkboxesNew[j].StringToObj[k].check) {
                                    counter++;
                                    onResultsFetchedTag.searchFacets += checkboxesNew[j].StringToObj[k].check ? counter > 1 ? "," + checkboxesNew[j].StringToObj[k].value : checkboxesNew[j].StringToObj[k].value : "";
                                }

                                /*  if (k < checkboxesNew[j].StringToObj.length - 1) {
                                      onResultsFetchedTag.searchFacets += checkboxesNew[j].StringToObj[k].check ?  checkboxesNew[j].StringToObj[k].value   : "";
                                  }
                                  else {
                                      onResultsFetchedTag.searchFacets += checkboxesNew[j].StringToObj[k].check ? checkboxesNew[j].StringToObj[k].value  : "";
                                  }*/
                            }
                            onResultsFetchedTag.searchFacets += ";";
                        }
                    }
                }
                if (onResultsFetchedTag.searchType == "aviation")
                    onResultsFetchedTag.searchType = onResultsFetchedTag.searchSubType;
                onResultsFetchedTag.searchFacets = onResultsFetchedTag.searchFacets.substring(0, 150);
                blockEventCapture(onResultsFetchedTag);
            }, 1000);

        } else if (eventTarget) {

            var tags = parseDynamicValues($(eventTarget), tempEventObj, null, buttonElementText, angularComponentname);
            if (typeof (fromAngular) === "object" && fromAngular.elementText) {
                if (selector === "OnFormSuccessfulSubmit") {
                    if (buttonElementText && typeof buttonElementText === "object") {
                        Object.keys(buttonElementText).forEach(function (key) {
                            if (tags.hasOwnProperty(key)) {
                                tags[key] = buttonElementText[key];
                            }
                        });
                
                        blockEventCapture(tags);
                        return;
                    }
                } 
                else{
                  $.extend(true, tags, fromAngular);
                }
            }
            blockEventCapture(tags);
        } else {
            var tags1 = parseDynamicValues($(eventsObj + " " + selector), tempEventObj, null, buttonElementText, angularComponentname);
            blockEventCapture(tags1);
        }
    }
    $("body").on(eventsObj.eventType, selector, function (e, dynamicEvents) {
        
        var tags = parseDynamicValues($(this), eventsObj, dynamicEvents, buttonElementText, angularComponentname);
        if ($(this).attr("isSubmittedFlag") == "true" && eventsObj.eventType === "submit") {
            $(this).attr("isSubmittedFlag", false);
                blockEventCapture(tags);
        } else if (eventsObj.eventType !== "submit") {
            blockEventCapture(tags);
        }
    });

}

function parseDynamicValues(evtTgt, eventsObj, event, buttonElementText, angularComponentname) {
    var obj = eventsObj.tags,
        formcheck = eventsObj.eventTarget;//form.ContactFormChemicals//
    tag = clearDataLayerValues($.extend(true, {}, obj), formcheck); // Deep copy to avoid modifying original object

    if(getNewChemicalAnalytics(eventsObj, evtTgt)){
        tag = getNewChemicalAnalytics(eventsObj, evtTgt);
    }
    else {
        $(Object.keys(obj)).each(function (i, key) {

            if ($.type(obj[key]) === "array" || $.type(obj[key]) === "object") {
                switch (key) {
                    case "componentName":
                    case "componentId":
                    case "event":
                    case "eventType":
                    case "elementText":
                    case "elementType":
                    case "titleText":
                        tag[key] = parseConditionalType(obj[key], evtTgt).toLowerCase();
                        break;
                    case "listOrdinal":
                        tag[key] = getListOrdinal(evtTgt, obj[key]);
                        break;
                }
            } else if ($.type(obj[key]) === "string") {

                var id = obj.componentId;
                if ($.type(id) === "array" || $.type(id) === "object") {
                    id = tag["componentId"];
                }

                switch (key) {
                    case "destinationUrl":
                        if (tag.componentId != "fo02") {
                            var url = getDestinationUrl(evtTgt, event) ? getDestinationUrl(evtTgt, event).toLowerCase() : "";
                            if (url.indexOf('mailto:') === -1 && url.indexOf('tel:') === -1 && url.indexOf('fax:') === -1) {
                                tag[key] = url;
                            } else if (url.indexOf('mailto:') !== -1 && id === 'et') {
                                tag[key] = url;
                            }
                        }
                        else if (tag.componentId == "fo02" && tag.anchorTag == "anchor-link") {
                            var urlnew = getDestinationUrl(evtTgt, event) ? getDestinationUrl(evtTgt, event).toLowerCase() : "";
                            tag[key] = urlnew;
                        }
                        break;
                    case "parentOrdinal":
                        tag[key] = getParentOrdinal(evtTgt);
                        break;
                    case "elementText":
                      if (obj.event !== "contact") {
                            tag[key] = getElementText(id, evtTgt, event, buttonElementText, angularComponentname, obj)?.trim()?.toLowerCase();
                        }
                        break;
                    case "eventLabel":
                        tag[key] = getEventLabel(evtTgt, id, event).trim();
                        break;
                    case "fileName":
                        tag[key] = getFileName(evtTgt).toLowerCase().toLowerCase();
                        break;
                    case "searchTerm":
                        tag[key] = getSearchTerm(id, evtTgt).toLowerCase();
                        break;
                    case "titleText":
                        tag[key] = getTitleText(id, evtTgt, event).trim().toLowerCase();
                        break;
                    case "parentName":
                        tag[key] = obj[key] !== "" ? obj[key] : getParentName(evtTgt).toLowerCase();
                        break;
                    case "searchType":
                        tag[key] = getSearchType(obj[key], evtTgt).toLowerCase();
                        break;
                    case "searchSubType":
                        tag[key] = getSearchSubType(obj[key], evtTgt).toLowerCase();
                        break;
                    case "parentItemText":
                        tag[key] = getParentItemText(evtTgt).trim().toLowerCase();
                        break;
                    case "parentTitle":
                        tag[key] = getParentTitle(id, evtTgt).trim().toLowerCase();
                        break;
                    case "parentListSource":
                        tag[key] = getParentListSource(evtTgt).trim().toLowerCase();
                        break;
                    case "listSource":
                        tag[key] = getDataSource(evtTgt).toLowerCase();
                        break;
                    case "formName":
                        tag[key] = getFormName(evtTgt);
                        break;
                    case "formTitle":
                        tag[key] = getFormTitle(evtTgt).toLowerCase();
                        break;
                    case "formDropdowns":
                        tag[key] = getFormDropdowns(evtTgt);
                        break;
                    case "resultType":
                        tag[key] = getResultType(evtTgt).trim().toLowerCase();
                        break;
                    case "searchResults":
                        tag[key] = getSearchResultCount(evtTgt, event);
                        break;
                    case "showMore":
                        tag[key] = getShowMore(evtTgt, event);
                        break;
                    case "searchFacets":
                        if ($(evtTgt).parents(".product-selector").length) {
                            tag[key] = getFacetVal();

                        } else {
                            tag[key] = getSearchFacets(evtTgt);
                        }
                        break;
                    case "refinementCategory":
                        tag[key] = getRefinementCategory(evtTgt, event).toLowerCase();
                        break;
                    case "eventType":
                        tag[key] = getEventType(obj[key], event).toLowerCase();
                        break;
                    case "starRating":
                        tag[key] = getStarRating(evtTgt).toLowerCase();
                        break;
                    case "highlyRec":
                        tag[key] = $(evtTgt).closest('.row').find('.btn-recomendation').length > 0 ? 'yes' : 'no';
                        break;
                    case "slidePosition":
                        tag[key] = getSlidePosition(evtTgt);
                        break;
                    case "imgsrcTag":
                        tag[key] = getImgSrcTag(evtTgt).trim().toLowerCase();
                        break;
                    case "page_title":
                        tag[key] = getPageTitle(evtTgt).trim();
                        break;
                    case "page_bu":
                        tag[key] = getBuType(evtTgt, id, event).trim();
                        break;
                    case "document_type":
                        tag[key] = getDocType(evtTgt).trim().toLowerCase();
                        break;

                    case "document_title":
                        tag[key] = getGtmVal(evtTgt).trim();
                        break;

                    case "video_id":
                        tag[key] = getVideoId(evtTgt);
                        break;
                    case "eventAction":
                        getEventAction(id, obj[key], event, evtTgt).then(function (e) {
                            tag[key] = e.trim();
                        });
                        break;
                    case "doc_path":
                        tag[key] = getWindowPathName().trim().toLowerCase();
                        break;
                    case "document_host":
                        tag[key] = getWindowOrigin().trim().toLowerCase();
                        break;
                    case "customer_type_selection":
                        tag[key] = customeTypeSelection(evtTgt).trim();
                        break;
                    case "primary_nature_of_inquiry_selection":
                        tag[key] = primaryNature(evtTgt).trim();
                        break;
                    case "job_role_selection":
                        tag[key] = jobRoleSelection(evtTgt).trim();
                        break;
                    case "location_selection":
                        tag[key] = locationSelectionVal(evtTgt).trim();
                        break;
                    case "industry_selection":
                        tag[key] = industrySelectionVal(evtTgt).trim();
                        break;
                    case "business_type_selection":
                        tag[key] = businessTypeVal(evtTgt).trim();
                        break;
                    case "primary_product_of_interest_selection":
                        tag[key] = primaryProductInterest(evtTgt).trim();
                        break;
                    case "other_product_of_interest_selection":
                        tag[key] = otherProducts(evtTgt).trim();
                        break;
                    case "event1":
                        getevent1(id, evtTgt).then(function (e) {
                            tag[key] = e.trim().toLowerCase();
                        });
                        break;
                    case "eventCategory":
                        tag[key] = getEventCategory(id, evtTgt).trim();
                        break;
                    case "page_type":
                        tag[key] = getPageType(evtTgt).trim();
                        break;
                    case "environment":
                        tag[key] = getEnvironmentType(evtTgt).trim().toLowerCase();
                        break;
                    case "page_language":
                        tag[key] = getPageLanguageType(evtTgt).trim();
                        break;
                    case "sitecore_contact_id":
                        tag[key] = getSitecoreContactId(evtTgt).trim().toLowerCase();
                        break;
                    case "pardot_cookie_id":
                        tag[key] = getPardotCookieId(evtTgt).trim().toLowerCase();
                        break;
                    case "distributor_search_country":
                        tag[key] = getCountryName(evtTgt).trim();
                        break;
                    case "external_url":
                        tag[key] = getExternalURL(evtTgt).trim();
                        break;
                    case "contentTitle":
                        if (tag.componentId === "sp03" && evtTgt.closest('.benefit-content')) {
                            tag[key] = evtTgt.closest('.benefit-content').find('.benefit-content__title')?.text()?.trim();
                        } else {
                            tag[key] = getContentTitle(evtTgt).trim();
                        }
                        break;
                    case "deviceType":
                        tag[key] = getDeviceType(evtTgt).trim();
                        break;
                    case "field_errors":
                        var dynamicKey = (typeof gtmEventErrorKey !== "undefined" && gtmEventErrorKey.length > 0) ? gtmEventErrorKey : "customer_support_field_errors";
                        if(dynamicKey !== "undefined"){
                            tag[dynamicKey] = getFieldErrors(id, obj[key], event, evtTgt);
                        }
                        break;          
                    case "componentType":
                        if (tag.componentId === "sp03" && evtTgt.closest('.benefit-content').length > 0) {
                            tag[key] = "benefitsContent";
                        }
                        break;
                    case "videoUrl":
                        if (tag.componentId === "sp02") {
                            tag[key] = evtTgt.find('iframe')?.attr('src');
                        }
                        break;
                    case "videoTitle":
                        if (tag.componentId === "sp02") {
                            tag[key] = evtTgt.find('iframe')?.attr('title');
                        }
                        break;
                }
            }
        });
    }

    return tag;
}

function getDestinationUrl($target, event) {
    var targetUrl = parseEvent(event, 'destinationUrl');
    if (targetUrl !== '') {
        return targetUrl;
    }
 
    if ($target.hasClass("no-global-analytics")) {
    return "";
   }

    var hrefValue = $target.attr("href");
    if ($target.parents(".c02-tabs").length > 0) {
        if (hrefValue && hrefValue.indexOf("section") > -1) {
            return '';
        }
    }

    hrefValue = (($target.parents().hasClass('a14-form-link')) && (($target.parents().find('.a14-form-link').attr("href")) == "#")) ? $target.parents().find('.a14-form-link').attr("data-href") : hrefValue;
    targetUrl = (hrefValue && hrefValue.indexOf("javascript") > -1) ? ($target.attr("data-destinationUrlValue") ? $target.attr("data-destinationUrlValue") : "") : (hrefValue ? hrefValue : ($target.attr("data-destinationUrlValue") ? $target.attr("data-destinationUrlValue") : ""));
    var parentElemUrl = $target.parents("a").attr("href");

    if ($target.closest(".sitecore-form").length) {
        if ($target.closest(".ContactFormChemicals").length) {
            targetUrl = window.location.href;
        }
    }
    if ($target.closest(".video-link-item, .image-link-item").length) {
        return '';
    }
    if ($target.is('a.sharethispage[data-bs-toggle*=modal]')) {
        return '';
    }

    return targetUrl ? targetUrl : parentElemUrl ? parentElemUrl : $target.val();
}

function getResultType($target) {

    if ($target.hasClass('ProductSeries_type'))
        return "product series";
    if ($target.hasClass('Product_type'))
        return "product";
    if ($target.hasClass('EquimentBuilder_Type'))
        return "equipment builder";

    if ($target.closest('.CoveoSearchInterface').hasClass('emebs'))
        return "equipment builder";

    // Chemical/FNL: read result type from .tag .label inside the nearest CoveoResult
    var $tagLabel = $target.closest('.CoveoResult').find('.tag .label');
    if ($tagLabel.length) {
        return $tagLabel.first().text().trim();
    }

    return "";
}

function getSearchTerm(id, $target) {
    var searchBox;
    var newSearchBox;
    var headerSearchBox = $target.parents('.nav-main-search').find('#txtSearch');
    var headerSearchTerm;
    var footerSearchBox = $target.parents('.footer-search-social').find('#footerTextSearch');
    var footerSearchTerm;
    if (footerSearchBox && footerSearchBox.length > 0) {
        footerSearchTerm = $target.parents('.footer-search-social').find('#footerTextSearch').val();
    }
    if (headerSearchBox && headerSearchBox.length > 0) {
        headerSearchTerm = $target.parents('.nav-main-search').find('#txtSearch').val();
    }
    switch (id) {
        case "hlr15":
            return $target.next(".CoveoOmnibox.magic-box").find("input").val();

        case "pse":
            return $target.parents('.search-box').find('#searchText').val();

        case "csb":
            // Check for E-search-panel or E-search-form__input
            if ($target.parents('.E-search-panel').length > 0) {
                var eSearchInput = $target.parents('.E-search-panel').find('#E-search-form__input');
                 if ($target.closest('.E-search-panel-popular__bd').length > 0) {
                    return $target.text();
                }
                if (eSearchInput.length > 0) {
                    return eSearchInput.val();
                }
            }
            var $searchInterface = $target.parents('.modal').length > 0 ? $('.body-content').find('.CoveoSearchInterface') : $target.parents('.CoveoSearchInterface');
            searchBox = $searchInterface.find(".CoveoOmnibox.magic-box");
            return (searchBox.length > 0 && $target.parent().hasClass('recent-searches-links') == false) ? searchBox.find("input").val() : ((headerSearchBox && headerSearchBox.length > 0) ? headerSearchTerm : ((footerSearchBox && footerSearchBox.length > 0) ? footerSearchTerm : (($target.parent().hasClass('recent-searches-links') == true) ? ($target[0].innerText) : " ")));
        case "crl":
        case "cf":
            if ($target.parent().hasClass('recent-searches-links')) {
                return $target[0].innerText;
            }
            return lastExecutedCoveoQuery;
        case "lbd":
        case "lcd":
        case "lcl":
        case "ldl":
        case "lf":
        case "lgd":
        case "li":
            searchBox = $target.parents('.product-locator').find('#searchContainer .input-group');
            newSearchBox = $target.parents('.product-locator-ff').find('#stationcontainer #searchContainer.input-group');
            if (searchBox.length) {
                return searchBox.find("input[type=search]").length ? searchBox.find("input[type=search]").val() : searchBox.find("input").val();
            }
            if (newSearchBox.length) {
                return newSearchBox.find("input[type=search]").length ? newSearchBox.find("input[type=search]").val() : newSearchBox.find("input").val();
            }
            return "";
        case "llf":
        case "loo":
        case "lsb":
        case "lrl":
        case "lsd":
        case "lstc":
        case "lvt":
        case "lwl":
        case "sp01":
            searchBox = $target.parents('.product-locator').find('#searchContainer .input-group');
            if (searchBox.length) {
                return searchBox.find("input[type=search]").length ? searchBox.find("input[type=search]").val() : searchBox.find("input").val();
            }
            newSearchBox = $target.parents('.product-locator-ff').find('#stationcontainer #searchContainer.input-group');
            if (newSearchBox.length) {
                return newSearchBox.find("input[type=search]").length ? newSearchBox.find("input[type=search]").val() : newSearchBox.find("input").val();
            }
            return "";

        //new ui gdl dropdown
        case "lrd":
            return $target.parent(".newGDLRadiusCol").parents().find("#searchInput").val();
        //return $(".newGDLRadiusCol").parents().find("#searchInput").val();
    }
    return "";
}

function getListOrdinal($target, loc) {
    var index = $target.index();
    if (loc) {
        index = $target.parents(loc.ref).find(loc.ele).index($target.closest(loc.ele));
    }
    return index + 1;
}

function getParentOrdinal($target) {
    var parent = $target.parents(".l01-list, .c02-tabs, .c01-accordion, .c03-carousel");

    // List
    if (parent.hasClass('l01-list')) {
        return getListOrdinal($target, { ref: '.l01-list', ele: 'li' });
    }

    // Tabs
    if (parent.hasClass('c02-tabs')) {
        return getListOrdinal($target, { ref: '.tab-content', ele: '.tab-pane' });
    }

    // Accordion
    if (parent.hasClass('c01-accordion')) {
        return getListOrdinal($target, { ref: '.c01-accordion>div', ele: '.accordion-item' });
    }

    // Carousel
    if (parent.hasClass('c03-carousel')) {
        var index = parseInt($target.parents('.slick-slide').data('slick-index'));
        if (index.isNaN) {
            return getListOrdinal($target, { ref: '.c03-carousel', ele: '.slick-slide' });
        }
        return index + 1;
    }

    if ($target.parents(".gallery-inner, .gallery-video-modal, .gallery-image-modal").length > 0) {
        var $galleryItem = $target.closest(".video-link-item, .image-link-item");
        if ($galleryItem.length) {
            return $galleryItem.closest('[data-item-number]').attr('data-item-number') || '';
        }
        else if ($target.closest('.gallery-video-modal, .gallery-image-modal').length > 0) {
            var modalId = $target.closest('.gallery-video-modal, .gallery-image-modal').attr('id');
            if (modalId) {
                var parentOrdinalVal = $('.gallery-inner.wep-gallery .row')
                    .find(`a[data-bs-target="#${modalId}"]`)
                    .closest('[data-item-number]')
                    .data('item-number') || '';
                return parentOrdinalVal;
            }
        }
    }

    return "";
}

function getParentItemText($target) {
    var parentTitle = $target.parents('.accordion-item').find('.accordion-header a');
    return parentTitle.length ? parentTitle.text() : "";
}

function getElementText(id, $target, event, buttonElementText, angularComponentname, obj){
    if ($target.closest(".ides-table").length) {
        return $target.attr('data-ides-column-name');
    } else if ($target.closest(".sds-search-result-list .pdsIcon").length) {
        return $target.attr('data-pds-column-name');
    }
    if ($target.closest(".gallery-inner").length > 0) {
        return $target.find("img").attr("alt");

    }
       if ($target.closest('.modal.gallery-video-modal, .modal.gallery-image-modal').length > 0) {
        var modalId = $target.closest('.modal').attr('id');
        switch (obj.eventType) {
            case "form initiation":
                var $anchor = $('[data-bs-target="#' + modalId + '"]');
                var altText = $anchor.length && $anchor.find('img').attr('alt');
                return altText;

            case "form cancel click":
                return $target.find('.form-cancel').attr('value');

            case "form unsuccessful submit":
            case "form successful submit":
                return $target.find('input[type="submit"]').attr('value');
        }
    }

    if ($target.closest('#Sharethispage').length > 0) {
        switch (obj.eventType) {
            case "form cancel click":
                return $target.find('.form-cancel').attr('value');

            case "form unsuccessful submit":
            case "form successful submit":
                return $target.find('input[type="submit"]').attr('value');
        }
    }

    var elText = parseEvent(event, 'elementText');
    if (elText !== '') {
        return elText;
    }
    
    switch (id) {
        case "a15":
            if ($target.children().hasClass("product-list-img")) {
                return parseFileName($target.children().attr("src"));
            }
            return $target.text();

        case "b03":
            if ($target.hasClass("product-list-image-link")) {
                return $target.closest(".product-list")?.find(".product-list-heading h4")?.text();
            }

            elText = $target.attr("src");
            if (elText) {
                return parseFileName(elText);
            }
            var childElem = $target.find("img").attr("src");
            if (childElem) {
                return parseFileName(childElem);
            }
            return "";
        case "mni":
            var mniElementText;
            if ($target.children().hasClass("nav-link-icon")) {
                mniElementText = $target.find('span').text();
                console.log('$target ', $target, ' elementText ', mniElementText);
            }
            else {
                if ($target.hasClass("w-100")) {
                    mniElementText = $target.find("img").attr("alt");
                }
                else {
                    mniElementText = $target.find("span").text();
                }
                console.log('$target ', $target, ' elementText ', mniElementText);
            }
            return mniElementText !== '' ? mniElementText : $target.text();

        case "c01":
        case "cl":
            return $target.closest("div").find("a:first").text();

        case "cf":
            var elementText = parseEvent(event, 'elementText');
            return elementText !== '' ? elementText : $target.text();

        case "f0":
            return $target.children('img').length > 0 ? "" : $target.text();

        case "fo02":
            if ($target.parents(".product-selector-form").length > -1) {
                return $target.text();
            }
            return $target.children('option:selected').text();

        case "fo":
            var originatingButton = parseEvent(event, "elementText");
            return originatingButton ? originatingButton : $('.lpg-form').length ? buttonElementText.toLowerCase() : $target.find('input[type="submit"]').attr('value')?.toLowerCase();

        case "hl":
            return $target.find("span:visible").text();
        case "hs01":
            var eleText = "";
            $(".hotspot__aside__item").each(function () {
                if (($(this).attr('data-numb')) == $target.attr('data-numb')) {
                    eleText = $(this).children('.title').text();
                    return false;
                }
            });
            return eleText;
        case "hs02":
            return ($target.text());
        case "hs03":
            return ($target.text());
        case "hs04":
            return $target.attr('data-productvalue');
        case "tl01":
            return $target.find('p').text();
        case "tl02":
            return $target.find('.title').text();
        case "tl03":
            return $target.attr("data-terminalName");
        case "tl04":
            return ($target.text());
        case "tl05":
            return ($target.text());
        case "lrd":
            return $target.children('option:selected').text();
        case "lf":
            var amenties = $target.closest('.form-amenities');
            return amenties.length ? amenties.text() : $target.parents('.input-container').text();

        case "ls":
            return $target.closest(".form-group").text();

        case "lcd":
        case "lbd":
        case "prl":
        case "psd":
            return $target.children('option').length ? $target.children('option:selected').text() : $target.text();

        case "lsd":
            if (!$target.hasClass('sort-by-filter')) {
                $target = $target.parents('.sort-results-by').find('.sort-by-filter');
            }
            return $target.children('option').length ? $target.children('option:selected').text() : $target.text();

        case "lgd":
        case "llf":
        case "ldl":
        case "lcl":
        case "loo":
            // If this is a click inside a map popup...
            elText = parseEvent(event, 'elementText');
            if (elText !== '') {
                return elText;
            }
            return $target.text();

        case "prd":
            return $target.children('img').length > 0 ? $target.parents('.promotion').find('.promotion-details a').text() : $target.text();

        case "psallr":
            if ($target.hasClass('accordion'))
                return $target.find('.notes-p').text();

            if ($target.is('select') || $target.parents().is('select'))
                return $target.find("option:selected").text();

            // This weird case is the proxy click for the "show more/fewer" button
            if ($target.hasClass('showTop') && $target.text() === '') {
                return $target.parents('.recommendations-view').find('.show-top').text();
            }
        
            return $target.text();

        case "pdtg":
            if ($target.hasClass('product-key-compare')) {
                return $target.find('.toggleKeys.d-none').text();
            }
            return $target.text();

        case "sp02":
        case "sp03":
            return parseEvent(event, "elementText");

        case "sp07":
            elText = $target.find("img").attr("src");
            if (elText) {
                var elemStr = elText.toLowerCase();
                if (elemStr.search("app-store") !== -1) {
                    return "iTunes";
                } else if (elemStr.search("play-store") !== -1) {
                    return "Google Play";
                }
            }
            return $target.text();

        case "x00":
            var prevSibling = $target.closest('.x00-thumbs-rating').siblings('.b01-paragraph');
            return prevSibling.length ? prevSibling.find('strong').text() : "";
        case "ce":
            if ($target.closest('#global-link-wrapper').length > 0) {
                return $target.text();
            }

            var ceElemText = '';

            if ($target.is('a')) {
                ceElemText = $target.text();
            }
            else {
                ceElemText = $target.closest("div").find("a:first").text();
            }
            return ceElemText;
        case "mtni":
            return $target.children(".nav-link-text").clone().children().remove().end().text().trim().toLowerCase();
        case "c04":
            if ($target.is('a.sharethispage[data-bs-toggle*=modal]')) {
                return "share page email icon";
            }
            return $target.find(".icon_container").text();
        case "ae":
            if ($target.is('button')) {
                const openText = $target.data('open-text');
                const closeText = $target.data('close-text');
                return $target.text() === openText ? closeText : openText;
            } else {
                return $target.find('.ff-details__accordion-header').text();
            }
        case "wl":
            if ($target.is('.E-identification__link.u-url')) {
                return $target.find('img').attr('alt') || "";
            }
        default:
            return (angularComponentname === 'newlocator' || $target[0].id === 'searchbuttonnewlocator') ? $target.find('img')[0].alt : $target.text();
    }
}

function getFileName($target) {

    var fileNameUrl = $target.attr("href"),
        parentNameUrl = $target.parents("a").attr("href"),
        dropDownUrl = $target.find(":selected").val(),
        files = ["pds", "pdf", "xls", "xlsx", "doc", "docx"];
    fileNameUrl = (($target.parents().hasClass('a14-form-link')) && (($target.parents().find('.a14-form-link').attr("href")) == "#")) ? $target.parents().find('.a14-form-link').attr("data-href") : fileNameUrl;

    if (fileNameUrl) {
        return fileNameIfContains(fileNameUrl, files);
    }
    if (parentNameUrl) {
        return fileNameIfContains(parentNameUrl, files);
    }
    if (dropDownUrl) {
        return fileNameIfContains(dropDownUrl, files);
    }

    return "";
}

function fileNameIfContains(url, str) {

    var contains = str.some(function (item) {
        return url.toLowerCase().indexOf(item) >= 0;
    });

    return contains ? parseFileName(url) : "";
}

function getTitleText(id, $target, event) {
    var elemText;
    var elemText2;
    switch (id) {
        case "c05":
        case "hlr14":
        case "b04":
            return ""; // Waiting for examples

        case "a04":
        case "a26":
            elemText = $target.closest("div").find(".field-title");
            if (elemText.length === 0 || elemText.text() === "") {
                elemText = $target.closest("div").find("h3");
            }
            break;

        case "a14":
            elemText = $target.parents('.modal-content').find('h3:first');
            if (elemText.length === 0) {
                elemText = $target.closest('.resource-list-title strong');
            }
            if (elemText.length === 0) {
                elemText = $target.parents('.a14-resource-list').prevAll('.b06-heading');
            }
            if (elemText.length === 0) {
                elemText = "";
                elemText2 = "";
            }
            break;

        case "a15":
            return $target.children().hasClass("product-list-img") ? $target.parent().siblings().find(".product-list-title a").text() : $target.text();

        case "a17":
            elemText = $target.siblings(".alert-title");
            break;

        case "a18":
            elemText = $target.closest('.list-items').find('h4');
            if (elemText.length === 0) {
                elemText = $target.closest('.list-items').find('.title');
            }
            break;

        case "a21":
            elemText = $target.closest('.a21-white-oil-product').find('h3');
            break;

        case "a22":
            elemText = $target.closest('.search-suggestions-text').find('.search-suggestions-title');
            return elemText.length ? elemText.text() : "";

        case "a24":
            elemText = $target.closest("div.component").find('h2');
            break;

        case "b07":
            elemText = $target.closest("div.component").find("div.secondary-title-title > h3");
            break;

        case "c02tic":
            elemText = $target.closest('.c02-tabs').find('.nav-link.active .field-heading');
            break;

        case "c04":
            var $galleryModal;
            elemText = $target.parent();
            if (elemText.parent().hasClass('modal-header')) {
                return elemText.parent().children('.modal-title').text();
            }
            else if (elemText.parent().children().hasClass('modal-header')) {
                return elemText.parent().children('div.modal-header').children('.modal-title').text();
            }
            if (elemText.find('.sharethispage').length) {
                const title = $target.find('.modal-header .modal-title').text();

                if (title) return title;

                if ($target.hasClass('sharethispage')) {
                    const targetSelector = $target.attr('data-bs-target');

                    if (targetSelector)
                        return $(targetSelector)
                            .find('.modal-header .modal-title')
                            .text();
                }
            }
            // If the target is the modal itself, return its h2
            if ($target.hasClass('gallery-video-modal') || $target.hasClass('gallery-image-modal')) {
                return $target.find('.gallery-form-title').text();
            }
            // If the target is a gallery link item, use data-bs-target to find the modal and its h2
            if ($target.hasClass('video-link-item') || $target.hasClass('image-link-item')) {
                var targetSelector = $target.attr('data-bs-target');
                if (targetSelector) {
                    $galleryModal = $(targetSelector);
                    if ($galleryModal.length > 0) {
                        return $galleryModal.find('.gallery-form-title').text();
                    }
                }
            }
            // If the target is inside a gallery modal, return the h2 of the closest modal
            $galleryModal = $target.closest('.gallery-image-modal, .gallery-video-modal');
            if ($galleryModal.length > 0) {
                return $galleryModal.find('.gallery-form-title').text();
            }
            return "";

        case "fo02":
            if ($target.parents(".product-selector-form").length > 0) {
                if ($($target.parents(".iconsCenter")[0]).length > 0) {
                    return $($target.parents(".iconsCenter")[0]).attr("data-icons-title");
                }
            }
            elemText = $target.closest(".form-group").find("label");
            break;
        case "prl":
            elemText = $target.closest(".form-group").find("label");
            break;

        case "psd":
            elemText = $target.parents('div.modal-content').find('div.pull-left h3');
            if (elemText.length === 0) {
                elemText = $target.parents('div.modal-content').find('span.pull-left h3');
            }
            break;

            case "lgd":
                var elemTextlgd = $target.parents(".result-wrapper.quite-padding").find(".fw-bold");
                var parentWrapperlgd = $target.closest(".result-wrapper");
                if (elemTextlgd.length > 0) {
                    return elemTextlgd.text();
                }
                else if($target.parents(".result-wrapper").find(".location-font").length>0) {
                    return $target.parents(".result-wrapper").find(".location-font").text();
                }
                else if (parentWrapperlgd.length > 0) {
                    var eleTextlgd = parentWrapperlgd.find(".media-body .fw-bold").text();
                    return eleTextlgd;  // Return null if no text is found
                }
                else if ($target.parents(".product-locator").length > 0) {
                    if($target.closest(".newGDLUIresultscontainer").length > 0) {
                        var newGDLUIresultscontainerTextlgd = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                        var newGDLUIresultTextlgd = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                        if(newGDLUIresultTextlgd.length > 0){
                            return newGDLUIresultTextlgd.text();
                        }
                        if(newGDLUIresultscontainerTextlgd.length > 0){
                            return newGDLUIresultscontainerTextlgd.text();
                        }
                    }
                    var tempmapDivlgd = document.createElement('div');
                    tempmapDivlgd.innerHTML = $target[0].innerHTML;
                    if( $(tempmapDivlgd.querySelector('.refineries-info-window .terminals h6')).length > 0) {
                        var textmaplgdrefineheading = tempmapDivlgd.querySelector('.refineries-info-window .terminals h6').innerText;
                        return textmaplgdrefineheading;
                    }
                    if( $(tempmapDivlgd.querySelector('.info-window .media .media-body h6')).length > 0) {
                        var textmaplgdheading = tempmapDivlgd.querySelector('.info-window .media .media-body h6').innerText;
                        return textmaplgdheading;
                    }
                    if ($(tempmapDivlgd.querySelector('.info-window .product-list-title')).length > 0) {
                        var textmaplgdprouctList = tempmapDivlgd.querySelector('.info-window .product-list-title').innerText;
                        return textmaplgdprouctList;
                    }
                    if( $(tempmapDivlgd.querySelector('.info-window a')).length > 0) {
                        var textmaplgd = tempmapDivlgd.querySelector('.info-window a').innerText;
                        return textmaplgd;
                    }
                }
                else if ($target.parents(".product-locator-ff").length > 0) {
                    if($($target.closest(".newGDLUIresultscontainer")).length > 0) {
                        var newGDLUIresultscontainerTextlgdff = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                        var newGDLUIresultTextlgdff = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                        if(newGDLUIresultTextlgdff.length > 0){
                            return newGDLUIresultTextlgdff.text();
                        }
                        if(newGDLUIresultscontainerTextlgdff.length > 0){
                            return newGDLUIresultscontainerTextlgdff.text();
                        }
                    }
                    var tempmapDivfflgd = document.createElement('div');
                    tempmapDivfflgd.innerHTML = $target[0].innerHTML;
                    if( $(tempmapDivfflgd.querySelector('.refineries-info-window .terminals h6')).length > 0) {
                        var textmaplgdrefineheading = tempmapDivfflgd.querySelector('.refineries-info-window .terminals h6').innerText;
                        return textmaplgdrefineheading;
                    }
                    if( $(tempmapDivfflgd.querySelector('.info-window .media .media-body h6')).length > 0) {
                        var textmapfflgdheading = tempmapDivfflgd.querySelector('.info-window .media .media-body h6').innerText;
                        return textmapfflgdheading;
                    }
                    if ($(tempmapDivfflgd.querySelector('.info-window .product-list-title')).length > 0) {
                        var textmaplgdffprouctList = tempmapDivfflgd.querySelector('.info-window .product-list-title').innerText;
                        return textmaplgdffprouctList;
                    }
                    if($(tempmapDivfflgd.querySelector('.info-window .brand-font')).length > 0) {
                        var textmapfflgd = tempmapDivfflgd.querySelector('.info-window .brand-font').innerText;
                        return textmapfflgd;
                    }
                    if( $(tempmapDivfflgd.querySelector('.info-window a')).length > 0) {
                        var textmapfflgd = tempmapDivfflgd.querySelector('.info-window a').innerText;
                        return textmapfflgd;
                    }
                }
                else if($target.closest(".product-list-description").length > 0){
                    var productText = $target.closest(".product-list-description").find(".product-list-title");
                    return productText.text();
                 }
                else {
                    return "";
                }
                break;
            case "ldl":
                var parentWrapperldl = $target.closest(".result-wrapper");
                var elemTextldl = $target.parents(".result-wrapper.quite-padding").find(".fw-bold");
                var elemTextldlBrand = $target.closest(".result-wrapper").find(".brand-address .brand-margin .location-font");
                if (elemTextldl.length > 0) {
                    return elemTextldl.text();
                }
                if (elemTextldlBrand.length > 0) {
                    return elemTextldlBrand.text();
                }
                if (parentWrapperldl.length > 0) {
                    var eleTextldl = parentWrapperldl.find(".media-body .fw-bold").text();
                    return eleTextldl;  // Return null if no text is found
                }
                if ($target.parents(".product-locator").length > 0) {
                    if($target.closest(".newGDLUIresultscontainer").length > 0) {
                        var newGDLUIresultscontainerText = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                        var newGDLUIresultText = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                        if(newGDLUIresultText.length > 0){
                            return newGDLUIresultText.text();
                        }
                        if(newGDLUIresultscontainerText.length > 0){
                            return newGDLUIresultscontainerText.text();
                        }
                        
                    }
                    var tempmapDivldl = document.createElement('div');
                    tempmapDivldl.innerHTML = $target[0].innerHTML;
                    if( $(tempmapDivldl.querySelector('.refineries-info-window .terminals h6')).length > 0) {
                        var textmapldlrefineheading = tempmapDivldl.querySelector('.refineries-info-window .terminals h6').innerText;
                        return textmapldlrefineheading;
                    }
                    if( $(tempmapDivldl.querySelector('.info-window .media .media-body h6')).length > 0) {
                        var textmapldlheading = tempmapDivldl.querySelector('.info-window .media .media-body h6').innerText;
                        return textmapldlheading;
                    }
                    if ($(tempmapDivldl.querySelector('.info-window .product-list-title')).length > 0) {
                        var textmapldlprouctList = tempmapDivldl.querySelector('.info-window .product-list-title').innerText;
                        return textmapldlprouctList;
                    }
                    if( $(tempmapDivldl.querySelector('.info-window a')).length > 0) {
                        var textmapldl = tempmapDivldl.querySelector('.info-window a').innerText;
                        return textmapldl;
                    }
                }
                if ($target.parents(".product-locator-ff").length > 0) {
                    if($($target.closest(".newGDLUIresultscontainer")).length > 0) {
                        var newGDLUIresultscontainerTextff = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                        var newGDLUIresultTextff = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                        if(newGDLUIresultTextff.length > 0){
                            return newGDLUIresultTextff.text();
                        }
                        if(newGDLUIresultscontainerTextff.length > 0){
                            return newGDLUIresultscontainerTextff.text();
                        }
                        return newGDLUIresultscontainerTextff;
                    }
                    var tempmapDivldlff = document.createElement('div');
                    tempmapDivldlff.innerHTML = $target[0].innerHTML;
                    if( $(tempmapDivldlff.querySelector('.refineries-info-window .terminals h6')).length > 0) {
                        var textmapldlffrefineheading = tempmapDivldlff.querySelector('.refineries-info-window .terminals h6').innerText;
                        return textmapldlffrefineheading;
                    }
                    if( $(tempmapDivldlff.querySelector('.info-window .media .media-body h6')).length > 0) {
                        var textmapldlheadingff = tempmapDivldlff.querySelector('.info-window .media .media-body h6').innerText;
                        return textmapldlheadingff;
                    }
                    if ($(tempmapDivldlff.querySelector('.info-window .product-list-title')).length > 0) {
                        var textmapldlffprouctList = tempmapDivldlff.querySelector('.info-window .product-list-title').innerText;
                        return textmapldlffprouctList;
                    }
                    if($(tempmapDivldlff.querySelector('.info-window .brand-font')).length > 0) {
                        var textmapldlff = tempmapDivldlff.querySelector('.info-window .brand-font').innerText;
                        return textmapldlff;
                    }
                }
                if($target.closest(".product-list-description").length > 0){
                    var productText = $target.closest(".product-list-description").find(".product-list-title");
                    return productText.text();
                 }
                break;
            case "llf":
            case "lcl":
                var parentWrapperlcl = $target.closest(".result-wrapper");
                var elemTextlcl = $target.parents(".result-wrapper.quite-padding").find(".fw-bold");
                if (elemTextlcl.length > 0) {
                    return elemTextlcl.text();
                }
                if (parentWrapperlcl.length > 0) {
                    var eleTextlcl = parentWrapperlcl.find(".media-body .fw-bold").text();
                    return eleTextlcl;  // Return null if no text is found
                }
                if ($target.parents(".product-locator").length > 0) {
                    if($target.closest(".newGDLUIresultscontainer").length > 0) {
                        var newGDLUIresultscontainerTextlcl = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                        var newGDLUIresultTextlcl = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                        if(newGDLUIresultTextlcl.length > 0){
                            return newGDLUIresultTextlcl.text();
                        }
                        if(newGDLUIresultscontainerTextlcl.length > 0){
                            return newGDLUIresultscontainerTextlcl.text();
                        }
                    }
                    var tempmapDivlcl = document.createElement('div');
                    tempmapDivlcl.innerHTML = $target[0].innerHTML;
                    if( $(tempmapDivlcl.querySelector('.refineries-info-window .terminals h6')).length > 0) {
                        var textmaplclrefineheading = tempmapDivlcl.querySelector('.refineries-info-window .terminals h6').innerText;
                        return textmaplclrefineheading;
                    }
                    if( $(tempmapDivlcl.querySelector('.info-window .media .media-body h6')).length > 0) {
                        var textmaplclheading = tempmapDivlcl.querySelector('.info-window .media .media-body h6').innerText;
                        return textmaplclheading;
                    }
                    if ($(tempmapDivlcl.querySelector('.info-window .product-list-title')).length > 0) {
                        var textmaplclprouctList = tempmapDivlcl.querySelector('.info-window .product-list-title').innerText;
                        return textmaplclprouctList;
                    }
                    if( $(tempmapDivlcl.querySelector('.info-window a')).length > 0) {
                        var textmaplcl = tempmapDivlcl.querySelector('.info-window a').innerText;
                        return textmaplcl;
                    }
                }
                if ($target.parents(".product-locator-ff").length > 0) {
                    if($target.closest(".newGDLUIresultscontainer").length > 0) {
                    var newGDLUIresultscontainerTextlclff = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                    var newGDLUIresultTextlclff = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                    if(newGDLUIresultTextlclff.length > 0){
                        return newGDLUIresultTextlclff.text();
                    }
                    if(newGDLUIresultscontainerTextlclff.length > 0){
                        return newGDLUIresultscontainerTextlclff.text();
                    }
                   }  
                    var tempmapDivfflcl = document.createElement('div');
                    tempmapDivfflcl.innerHTML = $target[0].innerHTML;
                    if( $(tempmapDivfflcl.querySelector('.refineries-info-window .terminals h6')).length > 0) {
                        var textmaplclffrefineheading = tempmapDivfflcl.querySelector('.refineries-info-window .terminals h6').innerText;
                        return textmaplclffrefineheading;
                    }
                    if( $(tempmapDivfflcl.querySelector('.info-window .media .media-body h6')).length > 0) {
                        var textmaplclffheading = tempmapDivfflcl.querySelector('.info-window .media .media-body h6').innerText;
                        return textmaplclffheading;
                    }
                    if ($(tempmapDivfflcl.querySelector('.info-window .product-list-title')).length > 0) {
                            var textmapfflclprouctList = tempmapDivfflcl.querySelector('.info-window .product-list-title').innerText;
                            return textmapfflclprouctList;
                    }
                    if ($(tempmapDivfflcl.querySelector('.info-window .brand-font')).length > 0) {
                        var textmapfflclbrandFont = tempmapDivfflcl.querySelector('.info-window .brand-font').innerText;
                        return textmapfflclbrandFont;
                    }
                }
               if($target.closest(".product-list-description").length > 0){
                var productText = $target.closest(".product-list-description").find(".product-list-title");
                return productText.text();
                }
                break;
        case "loo":
        case "lwl":
            // If this is a click inside a map popup...
            var elementText = parseEvent(event, 'titleText');
            if (elementText !== '') {
                return elementText;
            }

            elemText = $target.parent().siblings().find('.font-weight-bold');
            elemText2 = $target.parent().siblings().find('.location-font');
            if (elemText.length === 0) {
                elemText = $target.parent().parent().find('.font-weight-bold');
            }
            if (elemText.length === 0) {
                elemText = $target.parents('.result-wrapper').find('.font-weight-bold');
            }
            if (elemText.length === 0) {
                elemText = $target.parents('.product-list-description').find('.product-list-title');
            }
            if (elemText2.length === 0) {
                elemText2 = $target.parent().parent().find('.location-font');
            }
            if (elemText2.length === 0) {
                elemText2 = $target.parents('.result-wrapper').find('.location-font');
            }
            if (elemText2.length === 0) {
                elemText2 = $target.parents('.product-list-description').find('.product-list-title');
            }
            if (elemText.length === 0) {
                elemText = $target.parents(".gdlResultContainer").find(".gdlLink");
            }
            if($target.closest(".newGDLUIresultscontainer").length > 0) {
                var newGDLUIresultscontainerTextlwl = $($target[0].closest(".gdlResultContainer")).find(".gdlTitle");
                var newGDLUIresultTextlwl = $($target[0]).closest(".gdlResultContainer").find(".gdlResultLabel .gdlLink");
                    if(newGDLUIresultTextlwl.length > 0){
                        return newGDLUIresultTextlwl.text();
                    }
                    if(newGDLUIresultscontainerTextlwl.length > 0){
                        return newGDLUIresultscontainerTextlwl.text();
                    }
            }
            if($target.closest(".product-list-description").length > 0){
               var productText = $target.closest(".product-list-description").find(".product-list-title");
               return productText.text();
            }
            break;

        case "sp08":
            return $target.closest("div.component").find("div.station-locator-titles > h2").text();

        case "sp09":
            var $icon = $target.children("i");
            if ($icon.hasClass("icon-twitter")) {
                return "Twitter";
            } else if ($icon.hasClass("icon-facebook")) {
                return "Facebook";
            }
            return "";

        case "psil":
            elemText = $target.parents('.lists').find('.list-title');
            break;

        case "pdtg":
            elemText = $target.parents('.product-lists-container').find('h4');
            elemText = elemText.length ? elemText.first() : "";
            break;

        case "lclsd":
            if($target.parents(".station-locator-details").length > 0) {
                var ellclsd = $target.parents(".station-locator-details").find(".screen-title-title").text();
                var ellclsdhead = $target.parents(".station-locator-details").find("h1").text();
                if(ellclsd.length > 0) {
                    return ellclsd;
                }
                if(ellclsdhead.length > 0) {
                    return ellclsdhead;
                }
            }
            if($target.parents(".ff-details").length > 0) {
                parent = $target.closest('.body-content').find('.dynamicBanner__title').text();
                return parent;
            }
            break;
        case "lgdsd":
            if($target.parents(".ff-details").length > 0) {
                parent = $target.closest('.body-content').find('.dynamicBanner__title').text();
                return parent;
            }
            elemText = $target.parents('.locator-detail').find('.station-location-text');
            var customScreenTitle = $target.parents('.station-locator-details').find(".screen-title-title");
            if (customScreenTitle.length > 0) {
                return customScreenTitle.text();
            }
            if($target.parents(".station-locator-details").length > 0) {
                var elelgdsd = $target.parents(".station-locator-details").find('h1').text();
                return elelgdsd;
            }
            if (elemText.find('h3').length > 0) {
                elemText = elemText.find('h3');
            } else {
                elemText = $target.parents('.special-screen-distributor-details');
                if (elemText.length === 0) {
                    elemText = $target.parents('.gdl-detail');
                }
                var specialText = elemText.find('.special-screen-title-text').find('h3');
                if (specialText.length > 0) {
                    return specialText.text();  // Return h3 text from .special-screen-title-text
                }
            }
            break;
        case "lfssd":
            elemText = $('.find-station-link-new').length && $target[0].getAttribute('class') === 'find-station-link-new' ? $('.find-station-link-new') : $target.parents('.station-locator-details').find('h1');
            break;

        case "ldwl":
            elemText = $target.parents('.locator-detail').find('.station-location-text');
            elemText2 = $target.parents(".gdl-detail").find("h1");
            if (elemText.find('h3').length > 0) {
                elemText = elemText.find('h3');
            } else {
                elemText = $target.parents('.special-screen-distributor-details');
                if (elemText.length === 0) {
                    elemText = $target.parents('.gdl-detail');
                }
                elemText = elemText.find('.special-screen-title-text').find('h3');
            }

            break;
        case "ldwb":
            elemText = $target.parents('.locator-detail').find('.station-location-text');
            break;
        case "ldcl":
            elemText = $target.parents(".gdl-detail").find("h1");
            if(elemText.length > 0) {
                return elemText;
            }
            if($target.parents(".locator-detail").length > 0) {
                var eleldcl = $target.parents(".locator-detail").find(".station-location-text").text();
                var eleldclheading = $target.parents(".locator-detail").find(".station-location-text h3").text();
				if(eleldclheading.length > 0) {
                    return eleldclheading;
                }
				else{
                    return eleldcl;
                }
            }
            break;
        case "ldgd":
            elemText = $target.parents('.locator-detail').find('.station-location-text');
            if (elemText.find('h3').length > 0) {
                elemText = elemText.find('h3');
            } else {
                elemText = $target.parents('.special-screen-distributor-details');
                if (elemText.length === 0) {
                    elemText = $target.parents('.gdl-detail');
                }
                elemText = elemText.find('.special-screen-title-text').find('h3');
            }

            break;

        case "psallr":
            if ($target.is('select') || $target.parents().is('select')) {
                elemText = $target.closest('.drop-label-container').find('strong');
            } else {
                var cardTitle = $target.parents('.khws-product-card').find('.result-list-title');
                elemText = cardTitle.length ? cardTitle : $target.closest('.row').find('.result-list-title');
            }
            break;
        case "psbv":
            if ($target.is('select') || $target.parents().is('select'))
                elemText = $target.closest('.drop-label-container').find('strong');
            else
                elemText = $target.closest('.row').find('.result-list-title');
            break;

        case "psall":
            elemText = $target.parents('.input-group').find('label');
            break;

        case "et":
            elemText = $target.closest('.engage-tile__overlay').find('.engage-tile__heading p');
            break;

        case "ae": 
            elemText = $target.closest('.body-content')?.find('.dynamicBanner__title');
            break;

        case "ce":
            if ($target.closest('[id*="subMenu"]').length > 0) {
                if (window.innerWidth > 768) {
                    elemText = $target.closest('.brand-wrapper-region-site').find('.brand-title');;
                } else {
                    elemText = $target.closest('[id*="subMenu"]').find('.brand-title');
                }
            } else {
                return $target.text();
            }
            break;
        //case "ldl":
        //    elemText = $target.parents(".gdlResultContainer").find(".gdlLink").text();
        //    break;
        default:
            return $target.text();
    }
    return elemText && elemText.length ? elemText.text() : elemText2 && elemText2.length ? elemText2.text() : "";
}

function getFormTitle($target) {
    var title = $target.closest("form").find(".screen-title-title, h3");
    return title.length > 0 ? title.text() : "";
}

function getFormDropdowns($target) {

    var formDropdowns = [];
    $target.closest("form").find("select").each(function (i, select) {
        if (i > 2) return;
        formDropdowns.push({
            title: $(select).siblings('label').text().trim().toLowerCase(),
            value: $(select).children('option:selected').text().trim().toLowerCase()
        });
    });

    return formDropdowns;
}

function getEventType(staticEventType, event) {
    var eventType = parseEvent(event, "eventType");
    return eventType ? eventType : staticEventType;
}

function getStarRating($target) {
    var $star = $target.parents(".result-list").length && $target.parents(".result-list").find('bazaar-review').length ? $target.parents(".result-list").find('bazaar-review [itemprop="ratingValue"]') : [];
    if ($star.length) {
        return $star.text() + "/5";
    } else {
        return "0/5";
    }
}

function getRefinementCategory($target, event) {
    var eventType = parseEvent(event, "refinementCategory");
    if (eventType) return eventType;

    var $section = $target.closest('.dropselect');
    if ($section.length === 0) {
        $section = $target.closest('.row').parent().parent().siblings('.dropselect');
    }
    if ($section.length === 0) {
        $section = $target.parent().parent().find('.dropselect');
    }
    if ($section.length === 0) {
        $section = $target.closest('.drop-select');
    }
    if ($section.length === 0) {
        $section = $target.closest('.row').parent().parent().siblings('.drop-select');
    }
    if ($section.length === 0) {

        $section = $target.closest('.row').parent().parent().find('.drop-select');
        return $section.length ? $section.find('.refinementCategoryName').text().trim() : "";
    }
    return $section.length ? $section.find('.drop-label-container .refinementCategoryName').text() ? $section.find('.drop-label-container .refinementCategoryName').text().trim() : $section.find('.refinementCategoryName').text().trim() : "";
}

function getParentTitle(id, $target) {
    var parent;

    switch (id) {
        case "csb":
            return getParentName($target);

        case "a09":
        case "a08":
            var list = $target.parents(id === 'a09' ? '.a09-smart-list' : '.a08-smartlist');
            parent = list.parents('.c05-expanding-box');
            if (parent.length) {
                return parent.find('.expanding-box-trigger').length ? parent.find('.expanding-box-trigger').text() : "";
            }
            return list.length && list.siblings('h4').length ? list.siblings('h4').text() : "";

        case "x00":
            parent = $target.parents('body').find('h1:first');
            return parent.length ? parent.text() : "";

        case "psallr":
        case "psbv":
            parent = $target.parents('.recommendations-view').find('.tab-filter-row').find('.nav-link.active');
            return parent.length ? parent.text() : "";
        case "fo":
            var $modal = $target.parents('.gallery-video-modal, .gallery-image-modal');
            if ($modal.length > 0) {
                var modalId = $modal.attr('id');
                if (modalId) {
                    var $trigger = $("a[data-bs-target='#" + modalId + "']");
                    if ($trigger.length > 0) {
                        var $galleryTitle = $trigger.closest('.image-link-item, .video-link-item').next('.gallery-title-text');
                        if ($galleryTitle.length > 0) {
                            return $galleryTitle.text();
                        }
                    }
                }
            }
            if ($target.find('.product-selector-year') && $target.find('.product-selector-make') && $target.find('.product-selector-model')) {
                parent = (($('.product-selector-year') && $('.product-selector-year').length > 0) ? $('.product-selector-year').attr('value') : '') + " " + (($('.product-selector-make') && $('.product-selector-make').length > 0) ? $('.product-selector-make').attr('value') : '') + " " + (($('.product-selector-model') && $('.product-selector-model').length > 0) ? $('.product-selector-model').attr('value') : '');
            }
            return (parent && parent.length) ? parent : "";

        case "c04":
            var $modal = $target.closest('.gallery-video-modal, .gallery-image-modal');
            if ($modal.length > 0) {
                var modalId = $modal.attr('id');
                if (modalId) {
                    var $trigger = $("a[data-bs-target='#" + modalId + "']");
                    if ($trigger.length > 0) {
                        var $galleryTitle = $trigger.closest('.image-link-item, .video-link-item').next('.gallery-title-text');
                        if ($galleryTitle.length > 0) {
                            return $galleryTitle.text();
                        }
                    }
                }
            }

            // If target is within a gallery item (image-link-item or video-link-item)
            var $galleryItem = $target.closest('.image-link-item, .video-link-item');
            if ($galleryItem.length > 0) {
                var $galleryTitle = $galleryItem.next('.gallery-title-text');
                if ($galleryTitle.length > 0) {
                    return $galleryTitle.text();
                }
            }
            if ($target.find('.product-selector-year') && $target.find('.product-selector-make') && $target.find('.product-selector-model')) {
                parent = (($('.product-selector-year') && $('.product-selector-year').length > 0) ? $('.product-selector-year').attr('value') : '') + " " + (($('.product-selector-make') && $('.product-selector-make').length > 0) ? $('.product-selector-make').attr('value') : '') + " " + (($('.product-selector-model') && $('.product-selector-model').length > 0) ? $('.product-selector-model').attr('value') : '');
            }
            return (parent && parent.length) ? parent : "";
        case "ce":
            if ($target.closest('#global-link-wrapper').length > 0) {
                return ($target.attr('data-parent-title') || "").trim().toLowerCase();
            } 

            var ceParentTitle = "";
            if ($target[0].classList.contains("accordion-country-a")) {
                ceParentTitle = $target.closest(".accordion-separator").find(".accordion-header")[0].innerText;
            }
            else {
                ceParentTitle = $target.closest(".accordion-item").find(".accordion-header")[0].innerText;
            }
            return ceParentTitle;

        case "mni":
            if ($target.children(".nav-link-icon").length || ($target.closest("div").hasClass("nav-meganav-col"))) {
                var titletext = $target.parents(".nav-meganav-col").siblings(".meganav-subtitle").text();
                var titletext1 = $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("p");
                var titletext11 = $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("a.linknavigation");
                if (titletext == "" && titletext1.length > 0) {
                    return $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("p").text();
                }
                if (titletext == "" && titletext11.length > 0) {
                    return $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("a.linknavigation").text();
                }
                if (titletext == "") {
                    return $target.parents(".nav-meganav-col").siblings(".meganav-subtitle-container").text().trim();
                }
                return titletext;
            } else if (!($target.closest(".navbar-collapse").hasClass("show")) && ($target.parents(".noIconPadding").length > 0)) {

                if ($target.parents(".nav-expandable-menu-open").length) {
                    return $target.closest(".nav-expandable-menu").find("p").text();
                }
                else {
                    return $target.parents(".dropdown-menu.noIconPadding").prev('a').find('span').text().trim();
                }

            } else if (($target.closest(".navbar-collapse").hasClass("show")) && ($target.parents(".noIconPadding").length > 0)) {
                var titletext2 = $target.parents(".dropdown-menu.noIconPadding").prev('a').find('p').text().trim();
                if (titletext2 == "") {
                    return $target.parents(".dropdown-menu.noIconPadding").prev('a').find('span').text().trim();
                }
                return titletext2;
            }
            else {
                return $target.parents(".nav-meganav-subitem").find("span").first().text();
            }
            break;
        case "mm":
            if ($target.closest('.E-main-nav-list').length) {
                var $parentLi = $target.hasClass('--for-all')
                    ? $target.closest('li')
                    : $target.closest('li').parent('ul').closest('li');
                var $parentLabel = $parentLi.find('> a.nav-link, > span.--for-category').first();
                return $parentLabel.length ? $parentLabel.text().trim() : "";
            }
            if ($target.parents(".dropdown").length > 0) {
                if ($target.parents(".nav-expandable-menu-open").length) {
                    return $target.parents(".nav-expandable-menu-open").siblings(".nav-expandable-menu").children("a").text();
                } else if ($target.parent(".nav-meganav-subitem").length) {
                    return $target.parents(".nav-meganav-subitem").siblings(".nav-meganav-title").first().children("a").text();
                } else {
                    return $target.parents(".dropdown-menu").siblings(".nav-link").text();
                }
            } else {
                if ($target.parents(".nav-expandable-menu-open").length) {
                    return $target.parents(".nav-expandable-menu-open").siblings(".nav-expandable-menu").children("a").text();
                } else if ($target.parents(".meganav-subitem-container").length) {
                    return $target.parents(".meganav-subitem-container").siblings(".nav-meganav-title").first().children("a").text();
                } else if ($target.parents(".nav-main-mobile-panel").length > 0) {
                    //return $target.parent("li").siblings(".nav-main-mobile-back").children("a").text();
                    var titletextmobile = $target.parent("li").siblings(".nav-main-mobile-back").children("a.backnavigation").text().trim();
                    if (titletextmobile == "") {
                        return $target.parent("li").siblings(".nav-main-mobile-back").children("a").text().trim();
                    }
                    return titletextmobile;
                } else {
                    var eltext = $(".nav-main-item-active>a>span").text();
                    return eltext;
                }
            }
            break;

        case "ae": 
                if ($target.is('button')) {
                    return '';
                } else {
                    return $target.find('.ff-details__accordion-header').text();
                }
            break;
        default:
            if ($target.find('.product-selector-year') && $target.find('.product-selector-make') && $target.find('.product-selector-model')) {
                parent = (($('.product-selector-year') && $('.product-selector-year').length > 0) ? $('.product-selector-year').attr('value') : '') + " " + (($('.product-selector-make') && $('.product-selector-make').length > 0) ? $('.product-selector-make').attr('value') : '') + " " + (($('.product-selector-model') && $('.product-selector-model').length > 0) ? $('.product-selector-model').attr('value') : '');
                return (parent && parent.length) ? parent : "";
            } else {
                parent = $target.parents(".component").parents(".component");
                return parent.length && parent.find('h1').length ? parent.find('h1:first').text() : "";
            }
    }
}

function getShowMore($target) {
    var showMore = $target.parents('.CoveoSearchInterface').find(".showMoreResults:visible");
    return showMore.length > 0 && showMore.find("a:visible").length > 0 ? "1" : "0";
}

function getFacetVal() {
    var searchFacetData = "";
    var labelsLength = $(".dynamic-label").length;
    var val;
    if ($("[data-icons-title]").length) {
        searchFacetData += "'" + $("[data-icons-title]").attr("data-icons-title").trim() + "':" + $("[data-icons-title] .activeIcon").text().trim() + ",";
        // searchFacetData[$("[data-icons-title]").attr("data-icons-title").trim()] = $("[data-icons-title] .activeIcon").text().trim();
        if (labelsLength) {
            for (var j = 0; j < labelsLength; j++) {
                if ($(".dynamic-label").eq("" + j).text()) {
                    if ($("#select" + (j + 1)).find("option:selected").length && $("#select" + (j + 1)).find("option:selected").text().trim() !== "") {
                        val = $("#select" + (j + 1)).find("option:selected").text().trim();
                        if (j === labelsLength - 1)
                            searchFacetData += "'" + $(".dynamic-label").eq("" + j).text().trim() + "':" + val + "";
                        else
                            searchFacetData += "'" + $(".dynamic-label").eq("" + j).text().trim() + "':" + val + ",";

                        //searchFacetData[$(".dynamic-label").eq("" + j).text().trim()] = val;
                    }
                }
            }
        }
    }
    else if (labelsLength) {
        for (var i = 0; i < labelsLength; i++) {
            if ($(".dynamic-label").eq("" + i).text()) {
                if ($("#select" + (i)).find("option:selected").length && $("#select" + (i)).find("option:selected").text().trim() !== "") {
                    val = $("#select" + (i)).find("option:selected").text().trim();
                    if (i === labelsLength - 1)
                        searchFacetData += "'" + $(".dynamic-label").eq("" + i).text().trim() + "':" + val + "";
                    else
                        searchFacetData += "'" + $(".dynamic-label").eq("" + i).text().trim() + "':" + val + ",";
                    // searchFacetData[$(".dynamic-label").eq("" + i).text().trim()] = val;
                }
            }
        }
    }
    if (searchFacetData.length && searchFacetData.lastIndexOf(",") === searchFacetData.length - 1) {
        searchFacetData = searchFacetData.slice(0, searchFacetData.length - 1);
    }
    if (Object.keys(searchFacetData).length) {
        return JSON.stringify(searchFacetData).replace(/[{"'}]/gi, '').substring(0, 150);
    }
}

function getSearchFacets($target) {
    var $searchInterface =
        $target.parents('.modal').length > 0 || $target.parents('.E-search-panel').length > 0
            ? $('.body-content').find('.CoveoSearchInterface')
            : $target.parents('.CoveoSearchInterface');
    
    var facets = $searchInterface.find(".CoveoFacet .coveo-selected");
    if (facets.length) {

        // Loop through any ul with at least one selected li and build the string "category:value1,value2"
        return facets.parent().map(function (i, facetCategory) {

            var selectedValues = $(facetCategory).find('.coveo-selected').map(function (j, facetValue) {
                return $(facetValue).find('.coveo-facet-value-caption').text();
            }).toArray().join();

            return $(facetCategory).siblings('.coveo-facet-header').find('.coveo-facet-header-title').text() + ":" + selectedValues;

        }).toArray().join('_').substring(0, 150).toLowerCase();
    }

    return "";
}

function getParentName($target) {

    if ($target.parents('.a01-breadcrumb').length || $target.parents('.b01-breadcrumb').length) {
        return "breadcrumb";
    }

    if ($target.parents('header').length) {
        return "header";
    }

    if ($target.parents('footer').length) {
        return "footer";
    }
    if ($target.parents(".ticker_social").length) {
        return "ticker";
    }
    if (
        $target.parents('#Sharethispage').length ||
        $target.is('#Sharethispage')
    ) {
        return 'ShareThisPage';
    }
    if (
        $target.parents('.gallery-inner, .gallery-video-modal, .gallery-image-modal').length ||
        $target.is('.gallery-video-modal, .gallery-image-modal')
    ) {
        return 'wep gallery';
    }

    return getAnalyticsFor($target, "name", true);
}

function getSearchType(staticSearchType, $target) {

    if (staticSearchType !== "") return staticSearchType;

    var $searchInterface =
        $target.parents('.modal').length > 0 || $target.parents('.E-search-panel').length > 0
            ? $('.body-content').find('.CoveoSearchInterface')
            : $target.parents('.CoveoSearchInterface');

    if ($searchInterface.length) {
        if ($searchInterface.is('.global.library-search')) {
            return 'library';
        }
        if ($searchInterface.hasClass('pressrelease-search')) {
            return "newsroom";
        }
        if ($searchInterface.hasClass('global')) {
            return "global";
        }
        if ($searchInterface.hasClass('product-search')) {
            return "product";
        }
        if ($searchInterface.hasClass('pds')) {
            return "pds";
        }
        if ($searchInterface.hasClass('trsearch')) {
            return "technical resources";
        }
        if ($searchInterface.hasClass('ils')) {
            return "ils";
        }
        if ($searchInterface.hasClass('emebs')) {
            return "equipment builder";
        }
        if ($searchInterface.hasClass('events-search')) {
            return "event, webinar";
        }

        // If that doesn't work...
        if ($searchInterface.find('.CoveoForSitecoreConfigureSearchHub').length) {
            if ($searchInterface.find('.CoveoForSitecoreConfigureSearchHub').data('sc-search-hub') === "global-search-page") {
                return "global";
            }
        }

        if ($searchInterface.parents('header') || $searchInterface.parents('footer')) {
            return "global";
        }


    }
    if ($target && (($target.parents('header') && ($target.parent().parent().hasClass('nav-main-search'))) || ($target.parents('footer') && ($target.parents().hasClass('search-bar-footer-container'))))) {
        return "global";
    }
    
    // If no search interface found but target is in header and E-search-panel default to global
    if (!$searchInterface.length && ($target.parents('header').length && $target.parents('.E-search-panel').length)) {
        return "global";
    }
    
    var $productLocator = $target.parents('.product-locator');
    if ($productLocator.length && $productLocator.attr('data-app-config')) {
        var data = JSON.parse($productLocator.attr('data-app-config'));
        return data["MAP"] ? data["MAP"].datasource : "";
    }

    var $productLocatorFF = $target.parents('.product-locator-ff');
    if ($productLocatorFF.length && $productLocatorFF.attr('data-app-config')) {
        var data1 = JSON.parse($productLocatorFF.attr('data-app-config'));
        return data1["LocatorSettings"] ? data1["LocatorSettings"].DataSource : "";
    }

    return "";
}

function getSearchSubType(staticSearchType, $target) {
    var $productLocator = $target.parents('.product-locator');
    if ($productLocator.length && $productLocator.attr('data-app-config')) {

        var data = JSON.parse($productLocator.attr('data-app-config'));
        if (data.MAP && data["MAP"].datasource) {

            // Aviation
            if (data["MAP"].datasource.toLowerCase() === "aviation" && data.LOCATOR) {

                if (data["LOCATOR"].AviationLubes && data["LOCATOR"].AviationLubes.IsCurrentPage) {
                    return "aviation lubricants";
                }
                if (data["LOCATOR"].AviationFuels && data["LOCATOR"].AviationFuels.IsCurrentPage) {
                    return "aviation fuels";
                }
            }

            // Marine
            if (data["MAP"].datasource.toLowerCase() === "marine") {
                return "marine fuels";
            }

            // CVL
            if (data["MAP"].datasource.toLowerCase() === "truckstops") {
                var subType = $productLocator.find('.sort-component input:checked');
                return subType.length ? subType.val() : "";
            }

            // PVL, KHWS
            if (data["MAP"].datasource.toLowerCase() === "lubedba" || data["MAP"].datasource.toLowerCase() === "khws") {
                var lubeType = $productLocator.find('.pvl .btn-primary');
                if (lubeType.length) return lubeType.text();

                lubeType = $productLocator.find('.pvlrow .btn-primary');
                return lubeType.length ? lubeType.text() : "";
            }
        }
    }
    var $productLocatorFF = $target.parents('.product-locator-ff');
    if ($productLocatorFF.length && $productLocatorFF.attr('data-app-config')) {

        var data1 = JSON.parse($productLocatorFF.attr('data-app-config'));
        if (data1["LocatorSettings"] && data1["LocatorSettings"].DataSource) {

            // Aviation
            /* if (data1["LocatorSettings"].DataSource.toLowerCase() === "aviation" && data1.LOCATOR) {
 
                 if (data1["LOCATOR"].AviationLubes && data1["LOCATOR"].AviationLubes.IsCurrentPage) {
                     return "aviation lubricants";
                 }
                 if (data1["LOCATOR"].AviationFuels && data1["LOCATOR"].AviationFuels.IsCurrentPage) {
                     return "aviation fuels";
                 }
             }*/

            // Marine
            if (data1["LocatorSettings"].DataSource.toLowerCase() === "marine") {
                return "marine fuels";
            }

            // CVL
            if (data1["LocatorSettings"].DataSource.toLowerCase() === "truckstops") {
                var subType1 = $productLocatorFF.find('.sort-component input:checked');
                return subType1.length ? subType1.val() : "";
            }

            // PVL, KHWS
            if (data1["LocatorSettings"].DataSource.toLowerCase() === "lubedba" || data1["LocatorSettings"].DataSource.toLowerCase() === "khws") {
                var lubeType1 = $productLocatorFF.find('.pvl .btn-primary');
                if (lubeType1.length) return lubeType1.text();

                lubeType1 = $productLocatorFF.find('.pvlrow .btn-primary');
                return lubeType1.length ? lubeType1.text() : "";
            }
        }
    }

    return "";
}

function getDataSource($target) {
    var source = getAnalyticsFor($target, "source");

    if (source !== "") {
        return source;
    }

    if ($target.parents('.CoveoSearchInterface').length > 0) {
        return "onsite search";
    }

    return "";
}

function getFormName($target) {

    var formName = '';
    if ($target.find('input[type=hidden]').filter('[class]').attr('class') === 'form-initiation-title') {
        var formArray = $target.find('input[type=hidden]').filter('[class]');
        formArray.each(function () {
            if ($(this)[0].className === 'form-initiation-title') {
                formName = $(this)[0].value;
            }
        });
        return formName !== undefined ? formName.toLowerCase() : "";

    }
    else {
        formName = $target.find('input').filter('[sc-form-name]').attr('sc-form-name');
        return formName !== undefined ? formName.toLowerCase() : "";
    }

    // var formName = $target.find('input').filter('[sc-form-name]').attr('sc-form-name');
    // return formName !== undefined ? formName.toLowerCase() : "";


}

function getSearchResultCount($target, event) {
    var searchResultFromEvent = parseEvent(event, "searchResults");

    if (searchResultFromEvent !== "") return searchResultFromEvent.toString();

    var results = $target.parents('.CoveoSearchInterface').find('.CoveoQuerySummary');
    if (results.length > 0) {
        if (results.find('.coveo-query-summary-no-results-string').length) return "0";

        results = results.first().find('.coveo-highlight');
        //  return results.length < 2 ? "0" : (results.length === 2 ? results.last().text() : results.eq(2).text());
        if (window.location.href.indexOf('#q') !== -1) {
            return results.length < 2 ? "0" : (results.length === 3 ? results.eq(1).text() : results.eq(2).text());
        } else {
            return results.length < 2 ? "0" : results.last().text();
        }
    }
    // No query summary is on the page, return the count of coveoResults (won't account for paged items though)
    return $target.parents('.CoveoSearchInterface').find('.CoveoResult').length;
}

function getAnalyticsFor($target, dataName, forParent) {

    var analytics = (forParent ? $target.parents(".component") : $target).parents("[data-analytics]").data("analytics");
    return analytics && typeof analytics[dataName] !== 'undefined' ? analytics[dataName] : "";
}

var evaluate = function (exp, ctx) {
    var F = Function;
    return ctx ? (new F("context", "return " + exp))(ctx) : (new F("return " + exp))();
};

function parseConditionalType(eleType, evtCtx) {

    var matchedVal = "";
    $.each(eleType, function (i, ele) {
        if (evaluate(ele.rule, evtCtx)) {
            matchedVal = ele.value;
            return false;
        }
    });

    return matchedVal;
}

function parseEvent(event, eventName) {
    return event && typeof event[eventName] !== 'undefined' ? event[eventName] : "";
}

function parseFileName(url) {
    return url.substring(url.lastIndexOf("/") + 1, url.length);
}
function getParentListSource($target) {
    if ($target.closest('#global-link-wrapper').length > 0) {
        return ($target.attr('data-parent-list-source') || "").trim().toLowerCase();
    } 
    // E-nav: root level-1 nav text — always the main navigation label regardless of click depth
    if ($target.closest('.E-main-nav-list').length) {
        var $rootLi = $target.closest('.E-main-nav-list > li');
        var $rootLabel = $rootLi.find('> a.nav-link, > span.--for-category').first();
        return $rootLabel.length ? $rootLabel.text().trim() : "";
    }

    if ($target.closest("#nav-main-mobile").length > 0) {
        return $(".nav-parent-source").find("span").text().trim();
    }
    if ($target.parents(".navbar-main-header").find(".nav-main-bar").find(".dropdown-menu").first().length > 0) {
        return $target.parents(".dropdown-menu").siblings(".nav-link").text();
    }
    if ($target.parents('.nav-meganav-title').length || $target.parents(".meganav-subitem-container").siblings('.nav-meganav-title').length) {
        var parenttitletext = $(".nav-main-item-active>a>span").text();
        return parenttitletext;
    }

    if ($target.hasClass("dropdown-item")) {
        var listSourceText = $target.parents(".nav-meganav-col").siblings(".meganav-subtitle").text();
        var listsourcetext1 = $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("p");
        var listsourcetext2 = $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("a.linknavigation");
        if (listSourceText == "" && listsourcetext1.length > 0) {
            return $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("p").text();
        }
        if (listSourceText == "" && listsourcetext2.length > 0) {
            return $target.parents(".nav-meganav-subitem").parents(".nav-meganav-col").siblings(".menu-nav-indicatorNew-container").find("a.linknavigation").text();
        }
        if (listSourceText == "") {
            return $target.parents(".nav-meganav-col").siblings(".meganav-subtitle-container").text().trim();
        }
        return listSourceText;
    }
    if ($target.hasClass("linknavigation")) {
        var listSourceText2 = $target.text();
        if (listSourceText2 == "") {
            return $(".nav-main-item-active>a>span").text();
        }
        return listSourceText2;
    }
    return "";
}

//merged from chemicals
function getSlidePosition($target) {
    var carouselnewIndex = "";
    if (!$($target).closest(".carousel-multi-cols").length) {
        var carouselParent = $($target).closest(".t04-screen-title").parent();
        if (carouselParent.length > 0) {
            var carouselIndex = carouselParent[0].dataset.slickIndex;
            if (carouselIndex !== undefined) {
                carouselnewIndex = parseInt(carouselIndex) + 1;
            }
        }
    }
    return carouselnewIndex;
}
function getImgSrcTag($target) {
    var imgsrcValue = "";
    if (!$($target).closest(".carousel-multi-cols").length) {
        var imgsrcTag = $($target).closest(".t04-screen-title").find(".b03-image img");

        if (imgsrcTag.length > 0) {
            var imgsrcData = imgsrcTag[0].src;

            if (imgsrcData !== undefined) {
                imgsrcValue = imgsrcData;
            } else {
                imgsrcValue = "";
            }
        } else {
            imgsrcValue = "";
        }
    }
    return imgsrcValue;
}
function getBuType($target, id, event) {
    var buType = "";
    if (!$target || !$target.length) {
        console.error("Invalid $target in getBuType");
        return "";
    }
    if ($target.attr("data-gtmbusinessline")) {
        buType = $target.attr("data-gtmbusinessline");
        if(buType){
            return buType;
        }
        else {
            return "";
        }
    }
    if (typeof pageVariables !== 'undefined') {
        buType = pageVariables.BusinessUnit;
    }
    if ($target.closest('.ld-pdfrender').length > 0) {
        var customBuType = $target.closest('.ld-pdfrender').attr("data-gtmbusinessline");
        return customBuType || buType;  // Fallback to buType if customBuType is falsy
    }

    if ($target.closest('iframe').length > 0) {
        var customBuType1 = $target.closest('iframe').attr("data-gtmbusinessline");
        return customBuType1 || buType;  // Fallback to buType if customBuType is falsy
    }

    if ($($target.find('.vjs-tech')[0]).length > 0) {
        var customBuTypeVideo = $($target.find('.vjs-tech')[0]).attr("data-gtmbusinessline");
        return customBuTypeVideo || buType;  // Fallback to buType if customBuType is falsy
    }

    return buType;
}

function getPageTitle($target) {
    var assetTitle = "";
    if (typeof pageVariables !== 'undefined') {
        assetTitle = pageVariables.PageTitle;
    }

    if ($target.closest('.ld-pdfrender').length > 0) {
        var customTitle = $target.closest('.ld-pdfrender').attr("data-gtmbusinessline");
        return customTitle || assetTitle;
    }

    if ($target.closest('iframe').length > 0) {
        var customTitle1 = $target.closest('iframe').attr("data-gtmbusinessline");
        return customTitle1 || assetTitle;
    }

    return assetTitle;
}

function getEventLabel($target, id, event) {
    if ($target.closest(".static-table").length) {
        return "";
    }
    if ($target.closest(".ides-table").length) {
        return $target.attr('data-ides-event-label');
    }

    var eventLabel = "";
    var documentTitle = $target.closest('.ld-pdfrender').attr("data-gtmdocumenttitle");
    var gradeName = $("#lightbox-share input[data-sc-field-name='txtSubject']").val();
    if ($target.parents(".library-detail-component").length > 0) {
        var url = window.location.pathname; // Get the path from the URL
        var match = url.match(/\/library-detail\/(\d+)\//); // Extract the numeric ID after "/library-detail/"
        if (match) {
            return match[1]; // Output: 23053
        }
    }
    if ($target.parents(".enhanced-search-modal-video").length > 0 && $target.parents(".modal").length > 0){
        var videoId = $target.attr('data-video-id');
        var dataEventLabel = $('a[data-video-id="' + videoId + '"]').attr('data-event-label');

        if (dataEventLabel) {
            return dataEventLabel;
        } else {
            return "";
        }
    }
    var $galleryItem = $target.closest('.image-link-item, .video-link-item');
    if ($galleryItem.length > 0) {
        var $galleryLabel = $galleryItem.next('.gallery-title-text');
        if ($galleryLabel.length > 0) {
            return $galleryLabel.text();
        }
    }
    if ($target.attr("data-assetid")) {
        var pdfAsset = $target.attr("data-assetid");
        if(pdfAsset ){
            return pdfAsset;
        }
        else {
            return "";
        }
    }
    if ($target.attr("href")) {
        eventLabel = $target.attr("href");
        if ($target.find(".cardListModal__copy_title").length > 0) {
            return $target.find(".cardListModal__copy_title").text();
        }
        if ($target.parents(".c01-infinite-panels").length > 0) {
            return $target.text();
        }
        if ($target.parents(".product-list.ides-table").length > 0) {
            //return $target.closest("tr").find(".ides-subject").text();
            return $target.attr("href")?.match(/\/datasheets\/(\d+)\//)?.[1] || '';
        }
        if ($target.parents(".signpoly_productTable").length > 0) {
            return $target.closest(".group2").find(".pdsIcon a").attr('href')?.match(/\/(\d+)\.pdf/)?.[1] || '';
        }
        return eventLabel;
    }
    if (documentTitle) {
        eventLabel = documentTitle;
        return eventLabel;
    }
    if (gradeName) {
        eventLabel = gradeName;
        return eventLabel;
    }
    if ($target.closest('a').attr('href')) {
        var assetId = GetLibraryAssetIdForDownloadEvent($target.closest('a').attr('href'));
        eventLabel = assetId;
        return eventLabel;
    }
    if ($($target.find('.vjs-tech')[0]).length > 0) {
        var video_id_brightcove = $($target.find('.vjs-tech')[0]).attr("data-video-id");
        eventLabel = video_id_brightcove;
        return eventLabel;
    }



    if ($target.parents(".c02-tabs").length > 0) {
        if ($target.find(".field-heading").length > 0) {
            return $target.find(".field-heading").text();
        }
    }

    var elLabel = parseEvent(event, 'eventLabel');
    if (elLabel !== '') {
        return elLabel;
    }
    switch (id) {
        //case "c04":
        //    return $target.find(".cardListModal__copy_title").text() || $target.text();
        case "crl":
            return id === "crl" ? getSearchTerm(id, $target) : $target.text();
        
        case "fo":
            if ($target.closest(".sitecore-form").length) {
                if ($target.closest(".ContactFormChemicals").length) {
                    var errorlst = "";
                    $('.field-validation-error').each(function (index) {
                        var errorMsgFor = $(this).attr("data-valmsg-for");
                        var errorMsgField = $(".sitecore-form input[name='" + errorMsgFor + "'], textarea[name='" + errorMsgFor + "'], select[name='" + errorMsgFor + "']");
                        if (errorlst.indexOf($(errorMsgField).attr("data-sc-field-name")) == -1 && (typeof $(errorMsgField).attr("data-sc-field-name") !== "undefined")) {
                            errorlst = errorlst + "|" + $(errorMsgField).attr("data-sc-field-name");
                        }
                    });
                    // Remove the first "|"
                    errorlst = errorlst.substring(1);
                    if (typeof errorlst === "undefined") {
                        errorlst = "";
                    }
                    return errorlst;
                }
            }
            break;  // Keep this break for the "fo" case if no return occurs
        
    }
    return eventLabel;
}
function getFieldErrors(id, staticEventType, event, $target) {
    if ($target.closest(".sitecore-form").length) {
        if ($target.closest(".ContactFormChemicals").length) {
            var errorlst = "";
            $('.field-validation-error').each(function (index) {
                var errorMsgFor = $(this).attr("data-valmsg-for");
                var errorMsgField = $(".sitecore-form input[name='" + errorMsgFor + "'], textarea[name='" + errorMsgFor + "'], select[name='" + errorMsgFor + "']");
                if (errorlst.indexOf($(errorMsgField).attr("data-sc-field-name")) == -1 && (typeof $(errorMsgField).attr("data-sc-field-name") !== "undefined")) {
                    errorlst = errorlst + "|" + $(errorMsgField).attr("data-sc-field-name");
                }
            });
            // Remove the first "|"
            errorlst = errorlst.substring(1);
            if (typeof errorlst === "undefined") {
                errorlst = "";
            }
            return errorlst;
        }
    }
}
function GetLibraryAssetIdForDownloadEvent(hrefAttr) {
    var assetId = "";
    if (hrefAttr.split(/[\s/]+/)[3]) {
        assetId = hrefAttr.split(/[\s/]+/)[3];
        if (assetId.split('-')[0]) {
            assetId = assetId.split('-')[0];
        }
    }
    return assetId;
}

function getGtmVal($target, event) {
    var PDFTitle = $target.attr('data-GTMDownloadtitle');
    var gtmVal = "";
    var gradeName = $("#lightbox-share input[data-sc-field-name='txtSubject']").val();
    if (PDFTitle) {
        gtmVal = PDFTitle;
    }
    if (gradeName !== undefined) {
        gtmVal = gradeName;
    }
    if ($target.parents(".product-list.ides-table").length > 0) {
        return $target.closest("tr").find(".ides-subject").text();
    }
    if ($target.closest(".signpoly_productTable").length>0) {
        var $target = $target.closest('.productTable_content');
        return ($target.find('.gradeName_new span').text().trim() || '') !== '-'
            ? $target.find('.gradeName_new span:last').text().trim()
            : $target.find('.gradeName_old span:last').text().trim();
    }
    if ($target.closest(".static-table").length) {
        const docTitle = $target.attr('data-document-title');
        const fileNameParts = docTitle.split('.');
        if(fileNameParts.length > 1) fileNameParts.pop();
        const nameWithoutExt = fileNameParts.join('.');

        if (docTitle) {
            gtmVal = nameWithoutExt;
        }
    }
    if ($target.closest(".ides-table").length) {
        gtmVal = $target.attr('data-ides-document-title');
    }
    return gtmVal;
}
function getDocType($target, event) {
    var docType = "";
    var fileExtension = $target.attr('data-GTMFileExtension');
    var gradeName = $("#lightbox-share input[data-sc-field-name='txtSubject']").val();
    var videoTitle = $($target.find('.vjs-tech')[0]).attr("data-gtmdocumenttitle");
    if (fileExtension !== undefined) {
        if (fileExtension.startsWith('.')) {
            fileExtension = fileExtension.slice(1);
        }
        docType = fileExtension;
    }
    if (videoTitle !== undefined) {
        docType = videoTitle;
    }
    if ($target.parents(".product-list.ides-table").length > 0) {
        if (docType == "") {
            docType = "pdf";
        }
    }
    if ($target.closest(".signpoly_productTable").length>0) {
        return 'pdf';
    }
    if (gradeName) {
        docType = "pdf";
    }

    if ($target.closest(".static-table").length) {
        const docTitle = $target.attr('data-document-title');
        const fileNameParts = docTitle.split('.');
        const extension = fileNameParts.length > 1 ? fileNameParts.pop() : '';

        if (docTitle) {
            docType = extension;
        }
    }

    if ($target.closest(".ides-table").length) {
        docType = "pdf";
    }

    return docType;
}
function getVideoId($target, event) {
    var video_id = "";
    if ($target.closest('a').attr('href')) {
        var assetId = GetLibraryAssetIdForDownloadEvent($target.closest('a').attr('href'));
        video_id = assetId;
        return video_id;
    }

    if ($($target.find('.vjs-tech')[0]).length > 0) {
        var video_id_brightcove = $($target.find('.vjs-tech')[0]).attr("data-video-id");
        return video_id_brightcove;
    }
}
function getWindowOrigin() {
    return window.location.origin;
}

function getWindowPathName() {
    return window.location.pathname;
}
function getEventAction(id, staticEventType, event, $target) {
    return new Promise(function (resolve) {
        var windowPathName = window.location.pathname;
        if ($target.closest(".sitecore-form").length) {
            if ($target.closest(".sitecore-form").find(".ContactFormChemicals").length) {
                // If .ContactFormChemicals is present as a child (or deeper), resolve with "send " + staticEventType
                if ($(".ContactFormChemicals").find(".field-validation-error").length > 0) {
                    resolve(typeof staticEventType !== 'undefined' ?  eventActionVal + " Error" : "");
                }
                else {
                    var form = $target.closest(".sitecore-form")[0];
                    var scriptTag = form.querySelector("script");
                    var eventActionVal = "";
                    if (scriptTag) {  
                        var text = scriptTag.textContent;       
                        var actMatch = text.match(/var\s+eventActionVal\s*=\s*["']([^"']+)["']/m);
                        if (actMatch) {
                            eventActionVal = actMatch[1];
                        }
                        resolve(typeof staticEventType !== 'undefined' ? "Send " + eventActionVal : "");
                    }

                }
            } else {
                var gradeName = $("#lightbox-share input[data-sc-field-name='txtSubject']").val();
                if (gradeName) {
                    resolve('Email Product Data Sheet');
                } else {
                    resolve(typeof staticEventType !== 'undefined' ? staticEventType : "");
                }
            }
            return;
        }
        if ($target.closest(".slick-next").length) {
            resolve("Clicked on Carousel Slide right arrow");
            return;
        }
        if ($target.closest(".slick-prev").length) {
            resolve("Clicked on Carousel Slide left arrow");
            return;
        }
        if ($target.closest(".slick-dots").length) {
            resolve("Clicked on Carousel dots");
            return;
        }
        if ($target.closest(".c03-carousel").length) {
            resolve("Clicked on Carousel Slide");
            return;
        }

        if ($target.closest(".static-table").length || $target.closest(".ides-table").length) {
            resolve(staticEventType);
            return;
        }

        switch (id) {
            case 'crl':
                setTimeout(function () {
                    if (windowPathName.indexOf('search') !== -1) {
                        resolve('Site Search - Null Results');
                    } else if (windowPathName.indexOf('library') !== -1) {
                        if ($target.children(".icon-download-chem").length > 0) {
                            resolve("Document Downloaded");
                        } else if ($(".coveo-no-visible-facet").length > 0) {
                            resolve('Library Search - Null Results');
                        } else {
                            resolve('');
                        }
                    } else if ($target.attr("href") && $target.parents(".signpoly_productTable").length > 0) {
                        resolve("Document Downloaded");
                    } else {
                        resolve("");
                    }
                }, 5000);
                break;

            case "ce":
                resolve("Distributor Locator Search");
                break;
            case "a18":
                resolve("Visited Distributor Site");
                break;
            
            case 'sp03':
                var eventType = parseEvent(event, "eventType");
                resolve(eventType || staticEventType);
                break;
            case "a15":
                resolve("Document Downloaded");
                break;
            case "b05":
                resolve("Document Downloaded");
                break;

            default:
                resolve("");
                break;
        }
    });
}

function customeTypeSelection($target) {
    var customer_type_selection = checkUndefined($("input[data-sc-field-name='Customer_Type__c']:checked").val());
    return customer_type_selection;
}
function primaryNature($target) {
    var primary_nature_of_inquiry_selection = checkUndefined($("[data-sc-field-name='Primary_Nature_of_Inquiry__c']").find(":selected").val());
    return primary_nature_of_inquiry_selection;
}
function jobRoleSelection($target) {
    var job_role_selection = checkUndefined($("[data-sc-field-name='Job_Role__c']").find(":selected").val());
    return job_role_selection;
}

function locationSelectionVal($target) {
    var location_selection = "";
    if ($target.closest(".ContactFormChemicals").length > 0) {
        if ($("[data-sc-field-name='Location__c']").attr("data-valuefieldName")?.toLowerCase() == "value") {
            location_selection = checkUndefined($("[data-sc-field-name='Location__c']").attr("gtm-filtervalue"));
            return location_selection;
        }
        else {
            location_selection = checkUndefined($("[data-sc-field-name='Location__c']").val());
            return location_selection;
        }
    }

    return location_selection;
}
function industrySelectionVal($target) {
    var industry_selection = checkUndefined($("[data-sc-field-name='Industry__c']").find(":selected").val());
    return industry_selection;
}

function businessTypeVal($target) {
    var business_type_selection = checkUndefined($("[data-sc-field-name='Business_Type__c']").find(":selected").val());
    return business_type_selection;
}
function primaryProductInterest($target) {
    var primary_product_of_interest_selection = checkUndefined($("[data-sc-field-name='Primary_Product_of_Interest__c']").find(":selected").val());
    return primary_product_of_interest_selection;
}
function otherProducts($target) {
    var other_product_of_interest_selection = checkUndefined($("[data-sc-field-name='multiple-Other_Products_of_Interest__c']").val());
    var otherProducts = "";
    if ($("[data-sc-field-name='multiple-Other_Products_of_Interest__c']").attr("data-valuefieldName") != undefined && $("[data-sc-field-name='multiple-Other_Products_of_Interest__c']").attr("data-valuefieldName").toLowerCase() == "value") {
        $('.dropdown-content label').each(function () {
            var val = $(this).find("input:checked").attr("name");
            if (typeof val !== "undefined") {
                otherProducts = otherProducts + "," + val;
            }
        });
    }
    else {
        $('.dropdown-content label').each(function () {
            var val = $(this).find("input:checked").val();
            if (typeof val !== "undefined") {
                otherProducts = otherProducts + "," + val;
            }
        });
    }
    //remove the first ","
    other_product_of_interest_selection = otherProducts.substring(1);
    return other_product_of_interest_selection;
}

function getEventCategory(id, $target) {
    var eventCategory = "";
    if ($(".sitecore-form").length > 0) {
        if ($target.closest(".ContactFormChemicals").length > 0) {
            eventCategory = "Lead Generation";
        }
        if ($target.closest(".ContactFormChemicals").length === 0) {
            eventCategory = "Customer Enablement & Education";
        }
    }
    if ($target.closest(".c03-carousel").length > 0) {
        eventCategory = "UX";
    }
    if ($target.closest(".CoveoResultList").length > 0) {
        eventCategory = "Customer Enablement & Education";
    }
    if ($target.closest(".mf-player-container").length > 0) {
        eventCategory = "Media";
    }
    if ($target.parents(".c01-infinite-panels").length > 0) {
        eventCategory = "Customer Enablement & Education";
    }
    switch (id) {
        case "ldwl":
            return "Customer Enablement & Education";

    }
    return eventCategory;

}
function getevent1(id, $target) {
    return new Promise(function (resolve) {
        switch (id) {
            case "a18":
            case "ce":
                resolve("gaCustomEvents_distributor_locator");
                break;

            case "sp03":
                resolve("gaCustomEvents_video");
                break;

            case "c03":
                if ($target.closest(".carousel-multi-cols").length) {
                    if ($target.hasClass("slick-next")) {
                        resolve("gaCustomEvents_multislide_carousel_rightclick");
                    } else if ($target.hasClass("slick-prev")) {
                        resolve("gaCustomEvents_multislide_carousel_leftclick");
                    } else if ($target.hasClass("pager")) {
                        resolve("gaCustomEvents_carousel_dots");
                    }
                } else {
                    if ($target.hasClass("slick-next")) {
                        resolve("gaCustomEvents_carousel_rightclick");
                    } else if ($target.hasClass("slick-prev")) {
                        resolve("gaCustomEvents_carousel_leftclick");
                    }else if ($target.hasClass("pager") || $target.find("button")) {
                        resolve("gaCustomEvents_carousel_dots");
                    }
                }
                break;

            case "crl":
                // Handle asynchronous case
                setTimeout(function () {
                    if ($target.children(".icon-download-chem").length > 0) {
                        resolve("gaCustomEvents_doc_downloads");
                    } else if ($(".coveo-no-visible-facet").length > 0) {
                        resolve('gacustomevents_track_null_results_search_term_queries');
                    } else if ($(".signpoly_productTable").length > 0) {
                        resolve('gaCustomEvents_doc_downloads');
                    } else {
                        resolve('');
                    }
                }, 5000);
                break;

            case "fo":
                if ($target.closest(".sitecore-form").length) {
                  if ($target.closest(".ContactFormChemicals").length) {
                    var form = $target.closest(".sitecore-form")[0];
                    var scriptTag = form.querySelector("script");
                    var eventVal = "";
                    if (scriptTag) {
                        var text = scriptTag.textContent;
                        var eventMatch = text.match(/var\s+eventVal\s*=\s*["']([^"']+)["']/m);
                        if (eventMatch){ eventVal = eventMatch[1] };
                        resolve(typeof eventVal !== 'undefined' ? eventVal : "");
                    }
                    
                  }
                else {
                        resolve("gaCustomEvents_email_product_datasheet");
                    } // Ensure eventVal is defined
                }
                break;

            case "ldwl":
                resolve("gaCustomEvents_distributor_locator");
                break;

            case "t04":
                resolve("gaCustomEvents_carousel");
                break;
            case "a15":
                resolve("gaCustomEvents_doc_downloads");
                break;
            case "b05":
                resolve("gaCustomEvents_doc_downloads");
                break;

            default:
                resolve("");
                break;
        }
    });
}

function getPageType($target) {
    var page_type = "";

    if ($target.hasClass("location-info-website") || $target.hasClass("web") || $target.hasClass("countryname")) {
        page_type = "Distributor Page";
    } else if (typeof pageVariables !== 'undefined' && pageVariables.PageCategory) {
        page_type = pageVariables.PageCategory;
    }

    return page_type;
}

function getEnvironmentType($target) {
    var environment = "";

    if (typeof pageVariables !== 'undefined' && pageVariables.Environment) {
        environment = pageVariables.Environment;
    }

    return environment;
}
function getPageLanguageType($target) {
    var page_language = "";

    if (typeof pageVariables !== 'undefined' && pageVariables.SiteLanguageFullName) {
        page_language = pageVariables.SiteLanguageFullName;
    }
    return page_language;
}
function getSitecoreContactId($target) {
    var sitecore_contact_id = "";

    if (typeof pageVariables !== 'undefined' && pageVariables.SitecoreContactId) {
        sitecore_contact_id = pageVariables.SitecoreContactId;
    }
    return sitecore_contact_id;
}

function getPardotCookieId($target) {
    var pardot_cookie_id = "";

    if (typeof pageVariables !== 'undefined' && pageVariables.PardotCookieId) {
        pardot_cookie_id = pageVariables.PardotCookieId;
    }
    return pardot_cookie_id;
}
function getCountryName($target) {
    var countryName = "";
    if ($target.parents(".c01-infinite-panels").length > 0) {
        return $target.text();
    }
}

function getContentTitle($target) {
    var contentTitleLabel = $target.attr("aria-label") || "";
    var contentTitleValue = $target.find('.button-bar input[type="submit"]').first().val(); 
    var contentTitleLabel1 = $target.text().trim();
    
    // Priority: value attribute first, then aria-label, then inner text
    var contentTitle = contentTitleValue || contentTitleLabel || contentTitleLabel1 || "";
    return contentTitle;
}



function getExternalURL($target) {
    return $target.attr("href");
}
//merged from chemicals
function clearDataLayerValues(tag, formcheck) {
    tag["elementText"] = undefined;
    tag["destinationUrl"] = undefined;
    tag["listOrdinal"] = undefined;
    tag["titleText"] = undefined;
    tag["parentName"] = undefined;
    tag["parentOrdinal"] = undefined;
    tag["parentTitle"] = undefined;
    tag["fileName"] = undefined;
    tag["formName"] = undefined;
    tag["formTitle"] = undefined;
    tag["formDropdowns"] = undefined;
    tag["searchSubType"] = undefined;
    tag["searchTerm"] = undefined;
    tag["searchResults"] = undefined;
    tag["resultType"] = undefined;
    tag["showMore"] = undefined;
    tag["searchType"] = undefined;
    tag["parentListSource"] = undefined;

    //merged from chemicals
    if (tag.hasOwnProperty("slidePosition")) {
        tag["slidePosition"] = undefined;
    }
    if (tag.hasOwnProperty("imgsrcTag")) {
        tag["imgsrcTag"] = undefined;
    }
    if (tag.hasOwnProperty("page_title")) {
        tag["page_title"] = undefined;
    }
    if (tag.hasOwnProperty("page_bu")) {
        tag["page_bu"] = undefined;
    }
    if (tag.hasOwnProperty("eventLabel")) {
        tag["eventLabel"] = undefined;
    }

    if (tag.hasOwnProperty("document_title")) {
        tag["document_title"] = undefined;
    }
    if (tag.hasOwnProperty("document_type")) {
        tag["document_type"] = undefined;
    }
    if (tag.hasOwnProperty("external_url")) {
        tag["external_url"] = undefined;
    }
    if (tag.hasOwnProperty("video_id")) {
        tag["video_id"] = undefined;
    }
    if (tag.hasOwnProperty("customer_type_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["customer_type_selection"] = undefined;
    }
    if (tag.hasOwnProperty("primary_nature_of_inquiry_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["primary_nature_of_inquiry_selection"] = undefined;
    }
    if (tag.hasOwnProperty("job_role_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["job_role_selection"] = undefined;
    }
    if (tag.hasOwnProperty("location_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["location_selection"] = undefined;
    }
    if (tag.hasOwnProperty("industry_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["industry_selection"] = undefined;
    }
    if (tag.hasOwnProperty("business_type_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["business_type_selection"] = undefined;
    }
    if (tag.hasOwnProperty("primary_product_of_interest_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["primary_product_of_interest_selection"] = undefined;
    }
    if (tag.hasOwnProperty("other_product_of_interest_selection") && (formcheck == "form.ContactFormChemicals")) {
        tag["other_product_of_interest_selection"] = undefined;
    }
    if (tag.hasOwnProperty("event1")) {
        tag["event1"] = undefined;
    }
    if (tag.hasOwnProperty("eventCategory")) {
        tag["eventCategory"] = undefined;
    }
    if (tag.hasOwnProperty("page_type")) {
        tag["page_type"] = undefined;
    }
    if (tag.hasOwnProperty("environment")) {
        tag["environment"] = undefined;
    }
    if (tag.hasOwnProperty("page_language")) {
        tag["page_language"] = undefined;
    }

    if (tag.hasOwnProperty("sitecore_contact_id")) {
        tag["sitecore_contact_id"] = undefined;
    }
    if (tag.hasOwnProperty("pardot_cookie_id")) {
        tag["pardot_cookie_id"] = undefined;
    }
    if (tag.hasOwnProperty("distributor_search_country")) {
        tag["distributor_search_country"] = undefined;
    }
    if (tag.hasOwnProperty("contentTitle")) {
        tag["contentTitle"] = undefined;
    }
    if (tag.hasOwnProperty("deviceType")) {
        tag["deviceType"] = undefined;
    }
    return tag;
}

var formTimer;
function bindAnalyticsEvents() {

    $('.sitecore-form form').on('invalid-form.validate', function () {
        var $form = $(this);

        // Since multiple validation events may happen based on the form config, roll them up to one event
        clearTimeout(formTimer);
        formTimer = setTimeout(function () {
            $form.trigger('invalidForm');
        }, 1000);
    });

    $('.sitecore-form form .btn-cancel.form-cancel').on('click', function () {
        var cancelText = $(this).val();
        $(this).trigger('formCancel', [{ "elementText": cancelText }]);
    });

    $('.modal').on('shown.bs.modal', function (evt) {
        var button = evt.relatedTarget;
        var formInModal = $(this).find('.sitecore-form');

        if (formInModal.length > 0) {
            if (button !== undefined) {
                formInModal.find('form').trigger('formInit', [{ "elementText": $(button).text().length ? $(button).text() : "" }]);
            } else {
                formInModal.find('form').trigger('formInit', [{ "elementText": $('.sendResultsModalLink').text() }]);
            }

        }
    });

    $('#txtSearch').on('keydown', function (e) {
        var parentCheck = $(this).parents('.nav-main-header');
        if ((e.which === 13) && parentCheck) {
            $(this).trigger('SearchButtonText');
        }
    });
    $('#footerTextSearch').on('keydown', function (e) {
        var parentCheck = $(this).parents('.footer-search-social');
        if ((e.which === 13) && parentCheck) {
            $(this).trigger('SearchButtonText');
        }
    });
    $('.hotspot__aside__item').on('keypress', function (e) {
        if (e.which === 13) {
            $(this).trigger('HotspotSideNav');
        }
    });
    $('.hotspot__content__close').on('keypress', function (e) {
        if (e.which === 13) {
            $(this).trigger('HotspotCloseButton');
        }
    });
    // terminal hotspot locator keypress events

    $('.terminal-address').on('keypress', function (e) {
        if (e.which === 13) {
            $(this).trigger('terminalrightsection');
        }
    });
    $('.terminal__content__close').on('keypress', function (e) {
        if (e.which === 13) {
            $(this).trigger('terminaldetailclose');
        }
    });

    // Coveo facet analytics moved to _coveoAnalyticsConfig.js for centralized Coveo event handling

    locatorMapGAEventsHandler();

    // commenting to fix bug 30752
    // $('.CoveoSearchInterface').on('querySuccess', function (e, args) {
    //     $(this).find('.coveo-result-list-container').trigger('SearchResultsRendering', [{ "searchResults": args.results.totalCountFiltered }]);
    // });

    if (typeof Coveo !== 'undefined') {

        // Searchbox coveo is set up differently...for some reason
        Coveo.$('.nav-header, footer').find('.CoveoSearchbox input').on('keydown', function (e) {
            if (e.keyCode == 13) {
                $(this).parents('.CoveoSearchbox').trigger('SearchBoxSearch');
                $(".nav-main-item.nav-main-search-trigger.nav-main-item-active").trigger("click");
            }
        });

        Coveo.$('.nav-main-search.search-box .coveo-globalsearchbox .CoveoSearchButton').on('click', function () {
            $(".nav-main-item.nav-main-search-trigger.nav-main-item-active").trigger("click");
        });

        Coveo.$('.CoveoSearchInterface .magic-box-suggestions').click(function (e) {
            $(this).trigger('SearchBoxSuggestion');
            var inputText = Coveo.$(".CoveoSearchbox .magic-box-input").text();
            if (inputText.replace(/[-_;()]/gi, ' ').trim().replace(/[!%'"#<>\{\}\\\/]/gi, '') === '') {
                return false;
            }
            if ($("[name='Custom-Global-Search']").length) {
                var currentUrl = document.location.href;
                var facets = "";
                if (currentUrl.split("#").length > 1) {
                    facets = "&" + document.location.href.split("#")[1];
                }
                var urlToRedirect = $("[name='Custom-Global-Search']").val() + "#q=" + inputText.replace(/[-_;()]/gi, ' ').replace(/[!%'"#<>\{\}\\\/]/gi, '') + facets;
                document.location.href = window.encodeURI(decodeURI(sanitizeHtmlStrings(urlToRedirect)));
            }
        });
    }

    // Enhanced search panel analytics - these don't require Coveo object
    $('.E-search-panel').find('#E-search-form__input').on('keydown', function (e) {
        if (e.keyCode == 13) {
            $(this).trigger('SearchBoxSearch');
        }
    });

    // Enhanced header search analytics - Submit button click
    $('.E-search-panel').find('#E-search-form__button').on('click', function () {
        $('#E-search-form__input').trigger('SearchBoxSearch');
    });

    // Enhanced header search analytics - Auto-suggestion selection
    $('#autoSuggestionContainer').on('click', function () {
        $(this).trigger('SearchBoxSuggestion');
    });
}

function getHeroBannerAnalytics(eventObj, evtTgt){ 
    const tags = {...eventObj.tags}; 
    switch (eventObj.eventTarget) {
        case ".homeHero--itemCta":
            tags.heroBanner = {...tags.heroBanner, 
                tab : $(".homeHero--itemCta.active .homeHero--itemTitle").text().trim(),
                index: $(".homeHero--control .homeHero--itemCta.active").index()            }
            break;
        case ".homeHero--ctaContainer .cta-button a.button-primary": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL: evtTgt[0]?.href || "",
            }
            break;
            case ".homeHero--ctaContainer .cta-button a.button-secondary": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL: evtTgt[0]?.href || "",
            }
            break;
            case ".homeHero--ctaContainer .cta-button a.button-secondary-white": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL:evtTgt[0]?.href || "",
            }
            break;
            case  ".homeHero--ctaContainer .cta-button-popup-modal a.button-secondary": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL: evtTgt[0]?.href || "",
            }
            break;
            case ".homeHero--ctaContainer .cta-button-popup-modal a.button-secondary-white": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL: evtTgt[0]?.href || "",
            }
            break;
            case ".homeHero--ctaContainer .cta-button-popup-modal a.button-primary": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText:evtTgt[0]?.href || "",
            }
            break;
            case ".homeHero--ctaContainer a.button-tertiary": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL: evtTgt[0]?.href || "",
            }
            break;
            case ".homeHero--ctaContainer a.button-tertiary--white": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                ctaText: evtTgt[0].innerText,
                destinationURL: evtTgt[0]?.href || "",
            }
            break;
        case ".homeHero--playBtn": 
            tags.heroBanner = {...tags.heroBanner,
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
            }
            tags.interactionType = $(".pauseIcon").css("display") === "none" ? "Pause" : "Play";
        break;

    }
    return tags;
}

function getFeaturedContentAnalytics(eventObj, evtTgt){ 
   let tags = {...eventObj.tags}; 
   const featuredBox = evtTgt[0].closest(".featured-content__text-box");
   const headingEl = featuredBox?.querySelector("h1, h2, h3, h4, h5, h6");

    switch (eventObj.eventTarget) {
        case ".featured-content__text-box .cta-button a.button-primary":
            tags = {...tags,
                contentTitle: headingEl ? headingEl.innerText.trim() : "",
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".featured-content__text-box .cta-button a.button-secondary":
                tags = {...tags,
                    contentTitle: headingEl ? headingEl.innerText.trim() : "",
                    destinationURL: evtTgt[0]?.href || "",
                    deviceType: getDeviceType(),
                }
                break;
        case ".featured-content__text-box .cta-button a.button-secondary-white":
                    tags = {...tags,
                        contentTitle: headingEl ? headingEl.innerText.trim() : "",
                        destinationURL: evtTgt[0]?.href || "",
                        deviceType: getDeviceType(),
                    }
                break;
        case ".featured-content__text-box .cta-button-popup-modal a.button-secondary":
            tags = {...tags,
                contentTitle: headingEl ? headingEl.innerText.trim() : "",
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".featured-content__text-box .cta-button-popup-modal a.button-primary":
                tags = {...tags,
                    contentTitle: evtTgt[0].innerText.trim(),
                    destinationURL: evtTgt[0]?.href || "",
                    deviceType: getDeviceType(),
                }
                break;
        case ".featured-content__text-box .cta-button-popup-modal a.button-secondary-white":
                    tags = {...tags,
                        contentTitle: headingEl ? headingEl.innerText.trim() : "",
                        destinationURL: evtTgt[0]?.href || "",
                        deviceType: getDeviceType(),
                    }
                    break;
        case ".featured-content__text-box .cta-button a.button-tertiary":
            tags = {...tags,
                contentTitle: headingEl ? headingEl.innerText.trim() : "",
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".featured-content__text-box .cta-button a.button-tertiary--white":
            tags = {...tags,
                contentTitle: headingEl ? headingEl.innerText.trim() : "",
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".featured-content__text-box .cta-button-popup-modal a.button-tertiary":
            tags = {...tags,
                contentTitle: headingEl ? headingEl.innerText.trim() : "",
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".featured-content__text-box .cta-button-popup-modal a.button-tertiary--white":
            tags = {...tags,
                contentTitle: headingEl ? headingEl.innerText.trim() : "",
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
      
         case ".featured-content__copy a":
                tags = {...tags,
                    contentTitle: headingEl ? headingEl.innerText.trim() : "",
                    destinationURL: evtTgt[0]?.href || "",
                    deviceType: getDeviceType(),
                }
                break;
        case ".featured-content__playBtn":
            tags = {...tags, 
                contentTitle: $(".featured-content .featured-content__player").attr("alt"),
                destinationURL: evtTgt[0].parentElement.previousElementSibling.currentSrc,
                deviceType: getDeviceType()
            }
            break;
        case ".featured-content__big-play-icon":
            tags = {...tags,  
                contentTitle: evtTgt[0]?.nextElementSibling?.firstElementChild?.firstElementChild?.childNodes[3]?.childNodes[1]?.childNodes[1]?.title,
                destinationURL: evtTgt[0]?.nextElementSibling?.firstElementChild?.firstElementChild?.childNodes[3]?.childNodes[1]?.childNodes[1]?.src,
                deviceType: getDeviceType()
            }
            break;
    }
    return tags;
}

function getColorCardAnalytics(eventObj, evtTgt) {
    let tags = { ...eventObj.tags };
    
    switch (eventObj.eventTarget) {
       
        case ".heading-align-color-cards .heading-section a":
            tags = {
                ...tags,
                contentTitle: $(evtTgt[0]).closest(".heading-section").find(".heading-section__title-container").find("h1, h2, h3, h4, h5, h6").first().text().trim(),
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
        break;

        case ".card-body-color-card .cta-button a.button-primary":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
            }
        break;

        case ".card-body-color-card .cta-button a.button-secondary":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
        
            }
        break;

        case ".card-body-color-card .cta-button a.button-secondary-white":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
            }
        break;

        case ".card-body-color-card .cta-button-popup-modal a.button-secondary":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
            }
        break;

        case ".card-body-color-card .cta-button-popup-modal a.button-secondary-white":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
            }
        break;

        case ".card-body-color-card .cta-button a.button-tertiary":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
            }
        break;

        case ".card-body-color-card .cta-button-popup-modal a.button-tertiary":
            tags = {
                ...tags,
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
                contentTitle: $(evtTgt[0].closest(".card-content-color-card")).find(".card-header-color-card h3").text().trim(),
            }
        break;


    }
    return tags;
}




function getFeaturedCardsAnalytics(eventObj, evtTgt){ 
    let tags = {...eventObj.tags}; 
    switch (eventObj.eventTarget) {
        case ".featured-cards .heading-section .heading-section__title-container a":
            tags.featuredCards = {
                ...tags.featuredCards, 
                title: $(evtTgt[0]).closest(".heading-section").find(".heading-section__title-container").find("h1, h2, h3, h4, h5, h6").first().text().trim(),
                ctaText: $(evtTgt[0]).text().trim(),
                destinationURL: evtTgt[0]?.href || "",

            }
            break;
        case ".featured-cards .heading-section .heading-section__copy a":
        tags.featuredCards = {
            ...tags.featuredCards, 
            title: $(evtTgt[0]).closest(".heading-section").find(".heading-section__title-container").find("h1, h2, h3, h4, h5, h6").first().text().trim(),
            ctaText: $(evtTgt[0]).text().trim(),
            destinationURL: evtTgt[0]?.href || "",

        }
        break;
        case ".featured-cards .heading-section .heading-section__cta a":
            tags.featuredCards = {
                ...tags.featuredCards, 
                title: $(evtTgt[0]).closest(".heading-section").find(".heading-section__title-container").find("h1, h2, h3, h4, h5, h6").first().text().trim(),
                ctaText: $(evtTgt[0]).text().trim(),
                destinationURL: evtTgt[0]?.href || "",

            }
            break;     

        case ".featured-card .cta-button a.button-primary":
            tags.featuredCards = {
                ...tags.featuredCards, 
                title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                ctaText: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",

            }
            break;
        case ".featured-card .cta-button a.button-secondary":
                tags.featuredCards = {
                    ...tags.featuredCards, 
                    title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                    ctaText: evtTgt[0].innerText.trim(),
                    destinationURL: evtTgt[0]?.href || "",
    
            }
                break;
        case ".featured-card .cta-button a.button-secondary-white":
                    tags.featuredCards = {
                        ...tags.featuredCards, 
                        title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                        ctaText: evtTgt[0].innerText.trim(),
                        destinationURL: evtTgt[0]?.href || "",
        
        }
                    break;

        case ".featured-card .cta-button-popup-modal a.button-primary":
            tags.featuredCards = {
                ...tags.featuredCards, 
                title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                ctaText: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",

            }
            break;
            case ".featured-card .cta-button-popup-modal a.button-secondary":
                tags.featuredCards = {
                    ...tags.featuredCards, 
                    title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                    ctaText: evtTgt[0].innerText.trim(),
                    destinationURL: evtTgt[0].href,
    
                }
                break;
                case ".featured-card .cta-button-popup-modal a.button-secondary-white":
                    tags.featuredCards = {
                        ...tags.featuredCards, 
                        title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                        ctaText: evtTgt[0].innerText.trim(),
                        destinationURL: evtTgt[0].href,
        
                    }
                    break;

        case ".featured-card .cta-button-popup-modal a.button-tertiary":
            tags.featuredCards = {
                ...tags.featuredCards, 
                title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                ctaText: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",

            }
            break;
            case ".featured-card .cta-button a.button-tertiary":
                tags.featuredCards = {
                    ...tags.featuredCards, 
                    title: evtTgt[0].parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                    ctaText: evtTgt[0].innerText.trim(),
                    destinationURL: evtTgt[0]?.href || "",
    
                }
                    break;

        case ".featured-card__copy li a":
            tags.featuredCards = {
                ...tags.featuredCards, 
                title: evtTgt[0].parentElement?.parentElement?.parentElement?.parentElement?.querySelector('.featured-card__heading').innerText,
                ctaText: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",

            }
            break;

        case ".slick-prev":
            tags.featuredCards = {
                ...tags.featuredCards, 
            }
            break;

        case ".slick-next":
            tags.featuredCards = {
                ...tags.featuredCards, 
            }
            break;

        case ".slick-dots li":
            tags.featuredCards = {
                ...tags.featuredCards, 
            }
            break;
    }
    return tags;
}

function getCategoryContentAnalytics(eventObj, evtTgt){ 
    let tags = {...eventObj.tags}; 
    switch (eventObj.eventTarget) {
        
        case ".category-cards .category-card-main .category-card-item":
            tags = {...tags,

                contentTitle: evtTgt[0].querySelector("p").innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".category-cards .heading-section a.button-tertiary":
            tags = {...tags,
                contentTitle: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        }
        return tags;
} 

function getContentCardAnalytics(eventObj, evtTgt) {
    let tags = { ...eventObj.tags };

    switch (eventObj.eventTarget) {

        case ".contentCard_content .contentCard_copy a":
            tags = {
                ...tags,
                contentTitle: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
        case ".contentCard_content .cta-button a":
            tags = {
                ...tags,
                contentTitle: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
            case ".contentCard_content .cta-button-popup-modal a":
                tags = {
                    ...tags,
                    contentTitle: evtTgt[0].innerText.trim(),
                    destinationURL: evtTgt[0]?.href || "",
                    deviceType: getDeviceType(),
                }
                break;
        case ".heading-section a":
            tags = {
                ...tags,
                contentTitle: evtTgt[0].innerText.trim(),
                destinationURL: evtTgt[0]?.href || "",
                deviceType: getDeviceType(),
            }
            break;
    }
    return tags;
}
function getContentCalloutAnalytics(eventObj, evtTgt) {
    const contentCalloutSelectors = [
        ".item-wrapper .copy a",
        ".item-wrapper .cta-button a",
        ".item-wrapper .cta-button-popup-modal a"
    ];

    const $target = $(evtTgt[0]);

    // Check if the clicked element matches one of the selectors
    const matchedSelector = contentCalloutSelectors.find(selector => $target.is(selector));
    if (!matchedSelector) return { ...eventObj.tags };

    const elementClicked = matchedSelector === ".item-wrapper .copy a"
        ? "link"
        : $target.hasClass("button-tertiary") ? "link" : "button";

    const modalTargetSelector = $target.attr("data-bs-target");

    let tags = {
        ...eventObj.tags,
        destinationURL: evtTgt[0]?.href || "",
        contentTitle: $target.text().trim(),
        elementClicked,
        deviceType: getDeviceType()
    };

        if (modalTargetSelector) {
            // Step 1: Strip extra '#' for escaping (CSS.escape shouldn't include it)
            const rawSelector = modalTargetSelector.startsWith('#') 
                ? modalTargetSelector.slice(1) 
                : modalTargetSelector;

            try {
                // Step 2: Escape raw ID and build valid selector
                const escapedSelector = `#${CSS.escape(rawSelector)}`;
                
                // Step 3: Check if element exists before attaching event
                const $modal = $(escapedSelector);
                if ($modal.length > 0) {
                    $modal.one("shown.bs.modal", function () {
                        if ($modal.find("form").length > 0) {
                            tags.destinationURL = "Form";
                        }
                    });
                } else {
                    console.warn("Modal not found:", escapedSelector);
                }
            } catch (e) {
                console.error("Invalid modal selector:", modalTargetSelector, e);
            }
        }


    return tags;
}
function getProductCardAnalytics(eventObj, evtTgt) {
    const ProductCardSelectors = [
        ".product-cards-heading-section .heading-section a",
        ".prdcard .product-description a",
        ".prdcard.prdcard-exceedLink a",
        ".prdcard .cta-button a",
        ".prdcard .cta-button-popup-modal a",
        ".prdcard .prddropdown .ctalink"
    ];

    const $target = $(evtTgt[0]);

    // Check if the clicked element matches one of the selectors
    const matchedSelector = ProductCardSelectors.find(selector => $target.is(selector));
    if (!matchedSelector) return { ...eventObj.tags };

    const elementClicked = matchedSelector === ".prdcard .product-description a" ||
        matchedSelector === ".prdcard.prdcard-exceedLink a" ||
        matchedSelector === ".prdcard .prddropdown .ctalink" ||
        matchedSelector === ".product-cards-heading-section .heading-section a"
        ? "link"
        : $target.hasClass("button-tertiary") ? "link" : "button";

    const modalTargetSelector = $target.attr("data-bs-target");

    let tags = {
        ...eventObj.tags,
        destinationURL: evtTgt[0]?.href || "",
        contentTitle: $target.text().replace(/\s+/g, " ").trim(),
        elementClicked,
        deviceType: getDeviceType()
    };

    if (modalTargetSelector) {
        // Step 1: Strip extra '#' for escaping (CSS.escape shouldn't include it)
        const rawSelector = modalTargetSelector.startsWith('#')
            ? modalTargetSelector.slice(1)
            : modalTargetSelector;

        try {
            // Step 2: Escape raw ID and build valid selector
            const escapedSelector = `#${CSS.escape(rawSelector)}`;

            // Step 3: Check if element exists before attaching event
            const $modal = $(escapedSelector);
            if ($modal.length > 0) {
                $modal.one("shown.bs.modal", function () {
                    if ($modal.find("form").length > 0) {
                        tags.destinationURL = "Form";
                    }
                });
            } else {
                console.warn("Modal not found:", escapedSelector);
            }
        } catch (e) {
            console.error("Invalid modal selector:", modalTargetSelector, e);
        }
    }

    return tags;
}
function getContentC02CustomTabsLinksAnalytics(eventObj, evtTgt) {
    const tags = { ...eventObj.tags };

    if (eventObj.eventTarget === ".nav-tabs .tab-link.active") {

        const isDropdownActive =
            getComputedStyle(
                document.querySelector('.tab_component .dropdown-toggle')
            ).display !== 'none';
        return {
            ...tags,
            contentTitle: evtTgt[0]?.innerText.trim(),
            elementClicked: isDropdownActive ? 'drop-down' : 'tab',
 };
    }

    return tags;
}

function getSecondaryNavAnalytics(eventObj, evtTgt) {
    const tags = { ...eventObj.tags };
    const selectorList = [
        ".link-nav-wrapper .cta-button a.button-primary",
        ".link-nav-wrapper .cta-button a.button-secondary",
        ".link-nav-wrapper .cta-button a.button-secondary-white",
        ".link-nav-wrapper .cta-button a.button-tertiary",
        ".link-nav-wrapper .cta-button-popup-modal a.button-primary",
        ".link-nav-wrapper .cta-button-popup-modal a.button-secondary",
        ".link-nav-wrapper .cta-button-popup-modal a.button-secondary-white",
        ".link-nav-wrapper .cta-button-popup-modal a.button-tertiary"
    ];

    if (selectorList.includes(eventObj.eventTarget)) {
        const anchor = evtTgt[0];
        const container = anchor.closest(".secnav-banner-section");
        const titleContainer = container?.querySelector(".secnav-banner-section__title-container");

        // Find the first heading tag (h1 to h6) inside the container
        const heading = titleContainer?.querySelector("h1, h2, h3, h4, h5, h6, p");

        return {
            ...tags,
            contentTitle: heading ? heading.innerHTML.trim() : "",
            destinationURL: anchor?.href || "",
            deviceType: getDeviceType()
        };
    }



    return tags;
}

function getImageCardsAnalytics(eventObj, evtTgt) {
    const tags = { ...eventObj.tags };
    const selectorList = [".imageCard--overlay .cta-button a.button-primary", 
        ".imageCard--overlay .cta-button a.button-secondary",
            ".imageCard--overlay .cta-button a.button-secondary-white",
            ".imageCard--overlay .cta-button a.button-tertiary",
            ".imageCard--overlay .cta-button-popup-modal a.button-primary",
            ".imageCard--overlay .cta-button-popup-modal a.button-secondary",
            ".imageCard--overlay .cta-button-popup-modal a.button-secondary-white",
        ".imageCard--overlay .cta-button-popup-modal a.button-tertiary",
        ".heading-section__cta a.button-tertiary", ".heading-section__cta a.button-tertiary--white"];

            if (selectorList.includes(eventObj.eventTarget)) {
                const anchor = evtTgt[0];
                const elemenText = anchor.text.trim();
            
                const container = anchor.closest(".imageCard--card");
                const container1 = anchor.closest(".imageCard--copy");
                const titleContainer = container?.querySelector(".imageCard--card-content");
                const titleContainer1 = container1?.querySelector(".heading-section__title-container");
            
                const heading = titleContainer?.querySelector("h1, h2, h3, h4, h5, h6");
                const paraheading = titleContainer1?.querySelector("h1, h2, h3, h4, h5, h6");
            
                const contentTitle = heading?.innerHTML.trim() || paraheading?.innerHTML.trim() || "";
            
                return {
                    ...tags,
                    contentTitle: contentTitle,
                    destinationURL: anchor?.href || "",
                    deviceType: getDeviceType(),
                    elementText: elemenText
                };
            }
    return tags;
}

function getFooterAnalytics(eventObj, evtTgt) {
    const tags = { ...eventObj.tags };
    const selectorList = [".subscription-wrapper .cta-button a.button-primary", 
        ".subscription-wrapper .cta-button a.button-secondary", 
        ".subscription-wrapper .cta-button a.button-secondary-white",
        ".subscription-wrapper .cta-button-popup-modal a.button-primary", 
        ".subscription-wrapper .cta-button-popup-modal a.button-secondary", 
        ".subscription-wrapper .cta-button-popup-modal a.button-secondary-white",
        ".subscription-wrapper .cta-button-popup-modal a.button-tertiary",
        ".subscription-wrapper .cta-button a.button-tertiary"];
    if (selectorList.includes(eventObj.eventTarget)) {
        const contentTitle = $(evtTgt[0]).text().trim();
        var anchorLink = evtTgt[0];
        return {
            ...tags,
            contentTitle: contentTitle,
            destinationURL: anchorLink?.href || "",
            deviceType: getDeviceType(),
        };
    }
    return tags;
}

function getHeaderAnalytics(eventObj, evtTgt) {
    const tags = { ...eventObj.tags };
    const $target = $(evtTgt[0]);
    const innerText = $target.text().trim();
    const href = evtTgt[0]?.href || "";
    const deviceType = getDeviceType();

    // Format text like "contact us" to "ContactUs"
    const formatMenuText = text => text ? text.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('') : "";

    // Only fillout properties that exist in incoming tags
    function getSearchInputValue() {
        const searchInput = document.getElementById('E-search-form__input');
        return searchInput ? searchInput.value.trim() : "";
    }

    // Updated header analytics function
    return { ...tags,
        ...(tags && 'menuItem' in tags ? { menuItem: innerText } : {}),
        ...(tags && 'menuURL' in tags ? { menuURL: href || "" } : {}),
        ...(tags && 'menuSearch' in tags ? { menuSearch: getSearchInputValue() } : {}),
        ...(tags && 'deviceType' in tags ? { deviceType: deviceType } : {}),
        ...(tags && 'buttonClicked' in tags ? { buttonClicked: formatMenuText(innerText) } : {})
    }
}

function getModalPopupAnalytics (eventObj, evtTgt){
    const tags = { ...eventObj.tags };
    const selectorList = [".sp-modal-popup__content__actions .cta-button a.button-primary", 
        ".sp-modal-popup__content__actions .cta-button a.button-secondary", 
        ".sp-modal-popup__content__actions .cta-button a.button-secondary-white",
        ".sp-modal-popup__content__actions .cta-button a.button-tertiary",
        ".sp-modal-popup__content__actions .cta-button a.button-tertiary--white",
        ".modal-dialog-centered .modal-content .btn-close"];
    if (selectorList.includes(eventObj.eventTarget)) {

        let rawHref = evtTgt[0]?.href || ""; // read raw attribute value
        let href = "";
        if (rawHref && rawHref !== "#" && rawHref !== "javascript:void(0)") {
            href = rawHref;

        }

        return {
            ...tags,
            contentTitle: evtTgt[0].innerText?.trim() ||  evtTgt[0].getAttribute("aria-label") ||
            "",
            destinationURL: href, // updated to use the processed href
            deviceType: getDeviceType()
        };
    }
    return tags;
}

function getEnhSecondaryNavBarAnalytics(eventObj, evtTgt){ 
    let tags = {...eventObj.tags}; 
    switch (eventObj.eventTarget) {
        
    case ".enh-sec-nav__menu-items .sec-nav__dropdown .sec-nav__dropdown-menu a":
        tags = {
            ...tags,
            contentTitle: evtTgt[0].innerText.trim(),
            destinationURL: evtTgt[0]?.href || "",
            deviceType: getDeviceType(),
        }
        break;

    case ".enh-sec-nav__utility-bar .E-aside-nav-list a":
        tags = {
            ...tags,
            contentTitle: evtTgt[0].innerText?.trim() || evtTgt[0].title?.trim(),
            destinationURL: evtTgt[0]?.href || "",
            deviceType: getDeviceType(),
        }
        break;  
    }
    
    return tags;
} 

function getCTACalloutAnalytics(eventObj, evtTgt){ 
    let tags = {...eventObj.tags}; 
    const commonCTAButtonsSelectors = [
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-primary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-secondary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-secondary-white",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-primary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-secondary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-secondary-white",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-tertiary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-tertiary--white", 
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-tertiary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-tertiary--white",
    ];
    if (commonCTAButtonsSelectors.includes(eventObj.eventTarget)) {
        tags = {
            ...tags,
            contentTitle: evtTgt[0].innerText?.trim() || "",
            destinationURL: evtTgt[0]?.href || "",
            deviceType: getDeviceType()
        };
    }
   
    return tags;
}

function getDeviceType() {
    const userAgent = navigator.userAgent;
    const width = window.innerWidth;

    if(/Tablet|iPad/i.test(userAgent) || (width > 768 && width <= 1024)) {
        return "tablet";
    } else if (/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(userAgent)) {
        return "mobile";
    } else {
        return "desktop";
    }

}

function getNewChemicalAnalytics(eventsObj, evtTgt) {
    if([".homeHero--itemCta", 
        ".homeHero--ctaContainer .cta-button a.button-primary",
        ".homeHero--ctaContainer .cta-button a.button-secondary",
        ".homeHero--ctaContainer .cta-button a.button-secondary-white",
        ".homeHero--ctaContainer .cta-button-popup-modal a.button-secondary",
        ".homeHero--ctaContainer .cta-button-popup-modal a.button-secondary-white",
        ".homeHero--ctaContainer .cta-button-popup-modal a.button-primary",
        ".homeHero--ctaContainer a.button-tertiary--white",
        ".homeHero--ctaContainer a.button-tertiary",
        ".homeHero--playBtn"].includes(eventsObj.eventTarget)) return getHeroBannerAnalytics(eventsObj, evtTgt);
    if([".featured-content__text-box .cta-button a.button-primary",
        ".featured-content__text-box .cta-button a.button-secondary",
        ".featured-content__text-box .cta-button a.button-secondary-white",
        ".featured-content__text-box .cta-button-popup-modal a.button-primary",
        ".featured-content__text-box .cta-button-popup-modal a.button-secondary",
        ".featured-content__text-box .cta-button-popup-modal a.button-secondary-white",
        ".featured-content__copy a",
        ".featured-content__text-box .cta-button a.button-tertiary",
        ".featured-content__text-box .cta-button a.button-tertiary--white", 
        ".featured-content__text-box .cta-button-popup-modal a.button-tertiary",
        ".featured-content__text-box .cta-button-popup-modal a.button-tertiary--white",
        ".featured-content__playBtn", 
        ".featured-content__big-play-icon",
        ".featured-content__text-box .cta-button-popup-modal"].includes(eventsObj.eventTarget)) return getFeaturedContentAnalytics(eventsObj, evtTgt);
    if([".featured-cards .heading-section .heading-section__title-container a", 
        ".featured-cards .heading-section .heading-section__copy a",
        ".featured-cards .heading-section .heading-section__cta a",
        ".featured-card .cta-button a.button-primary", 
        ".featured-card .cta-button a.button-secondary",
        ".featured-card .cta-button a.button-secondary-white",
        ".featured-card .cta-button-popup-modal a.button-primary",
        ".featured-card .cta-button-popup-modal a.button-secondary",
        ".featured-card .cta-button-popup-modal a.button-secondary-white",
        ".featured-card .cta-button-popup-modal a.button-tertiary",
        ".featured-card .cta-button a.button-tertiary",
        ".featured-card__copy li a",
        ".slick-prev",
        ".slick-next",
        ".slick-dots li"
    ].includes(eventsObj.eventTarget)) return getFeaturedCardsAnalytics(eventsObj, evtTgt);
    if([
        ".heading-align-color-cards .heading-section a",
        ".card-body-color-card .cta-button a.button-primary",
        ".card-body-color-card .cta-button a.button-secondary",
        ".card-body-color-card .cta-button a.button-secondary-white",
        ".card-body-color-card .cta-button-popup-modal a.button-primary",
        ".card-body-color-card .cta-button-popup-modal a.button-secondary",
        ".card-body-color-card .cta-button-popup-modal a.button-secondary-white",
        ".card-body-color-card .cta-button a.button-tertiary",
        ".card-body-color-card .cta-button-popup-modal a.button-tertiary", 
    ].includes(eventsObj.eventTarget)) return getColorCardAnalytics(eventsObj, evtTgt);

    if ([".contentCard_content .contentCard_copy a",
        ".contentCard_content .cta-button a",
        ".heading-section a", ".contentCard_content .cta-button-popup-modal a"
    ].includes(eventsObj.eventTarget)) return getContentCardAnalytics(eventsObj, evtTgt);

    if ([".item-wrapper .copy a",
        ".item-wrapper .cta-button a",
        ".item-wrapper .cta-button-popup-modal a"
    ].includes(eventsObj.eventTarget)) return getContentCalloutAnalytics(eventsObj, evtTgt);

    if ([".featured-resources-heading-section .heading-section a",
        ".resource-item .resource-content-title a",
        ".resource-item .resource-copy a",
        ".resource-item .resource-cta a"
    ].includes(eventsObj.eventTarget)) return featuredResourcesAnalytics.getFeaturedResourcesAnalytics(eventsObj, evtTgt);

    if ([".product-cards-heading-section .heading-section a",
        ".prdcard .product-description a",
        ".prdcard.prdcard-exceedLink a",
        ".prdcard .cta-button a",
        ".prdcard .cta-button-popup-modal a",
        ".prdcard .prddropdown .ctalink"
    ].includes(eventsObj.eventTarget)) return getProductCardAnalytics(eventsObj, evtTgt);

    if ([".nav-tabs .tab-link.active"
    ].includes(eventsObj.eventTarget)) return getContentC02CustomTabsLinksAnalytics(eventsObj, evtTgt);

    if ([".nav-tabs .vertTab-link.active"
    ].includes(eventsObj.eventTarget)) return verticalTabsAnalytics.getVerticalTabsAnalytics(eventsObj, evtTgt);

    if ([".category-cards .category-card-main .category-card-item", ".category-cards .heading-section a.button-tertiary"].includes(eventsObj.eventTarget)) return getCategoryContentAnalytics(eventsObj, evtTgt);
    if ([".link-nav-wrapper .cta-button a.button-primary", ".link-nav-wrapper .cta-button a.button-secondary",
        ".link-nav-wrapper .cta-button a.button-secondary-white",
        ".link-nav-wrapper .cta-button a.button-tertiary",
        ".link-nav-wrapper .cta-button-popup-modal a.button-primary",
        ".link-nav-wrapper .cta-button-popup-modal a.button-secondary",
        ".link-nav-wrapper .cta-button-popup-modal a.button-secondary-white",
        ".link-nav-wrapper .cta-button-popup-modal a.button-tertiary"].includes(eventsObj.eventTarget)) return getSecondaryNavAnalytics(eventsObj, evtTgt);

    if ([".imageCard--overlay .cta-button a.button-primary", 
        ".imageCard--overlay .cta-button a.button-secondary", ".imageCard--overlay .cta-button a.button-secondary-white",
            ".imageCard--overlay .cta-button a.button-tertiary",
            ".imageCard--overlay .cta-button-popup-modal a.button-primary",
            ".imageCard--overlay .cta-button-popup-modal a.button-secondary",
            ".imageCard--overlay .cta-button-popup-modal a.button-secondary-white",
            ".imageCard--overlay .cta-button-popup-modal a.button-tertiary",".heading-section__cta a.button-tertiary",".heading-section__cta a.button-tertiary--white"].includes(eventsObj.eventTarget)) return getImageCardsAnalytics(eventsObj, evtTgt);
    
    if ([".subscription-wrapper .cta-button a.button-primary", 
            ".subscription-wrapper .cta-button a.button-secondary", 
            ".subscription-wrapper .cta-button a.button-secondary-white",
            ".subscription-wrapper .cta-button-popup-modal a.button-primary", 
            ".subscription-wrapper .cta-button-popup-modal a.button-secondary", 
            ".subscription-wrapper .cta-button-popup-modal a.button-secondary-white",
            ".subscription-wrapper .cta-button-popup-modal a.button-tertiary",
            ".subscription-wrapper .cta-button a.button-tertiary"].includes(eventsObj.eventTarget)) return getFooterAnalytics(eventsObj, evtTgt);
            
    if ([".E-utilities-item:not(.header-search)", ".E-aside-nav-link"
            ].includes(eventsObj.eventTarget)) return getHeaderAnalytics(eventsObj, evtTgt);

    if ([".enh-sec-nav__menu-items .sec-nav__dropdown .sec-nav__dropdown-menu a",
        ".enh-sec-nav__utility-bar .E-aside-nav-list a"
        ].includes(eventsObj.eventTarget)) return getEnhSecondaryNavBarAnalytics(eventsObj, evtTgt);

    if([".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-primary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-secondary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-secondary-white",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-primary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-secondary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-secondary-white",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button a.button-tertiary",
        ".cta-callout-collapsed .cta-callout__cta-section .cta-button-popup-modal a.button-tertiary",
       ].includes(eventsObj.eventTarget)) return getCTACalloutAnalytics(eventsObj, evtTgt);
       
    if ([".sp-modal-popup__content__actions .cta-button a.button-primary", 
    ".sp-modal-popup__content__actions .cta-button a.button-secondary", 
    ".sp-modal-popup__content__actions .cta-button a.button-secondary-white",
    ".sp-modal-popup__content__actions .cta-button a.button-tertiary",
    ".sp-modal-popup__content__actions .cta-button a.button-tertiary--white",
    ".modal-dialog-centered .modal-content .btn-close"].includes(eventsObj.eventTarget)) return getModalPopupAnalytics(eventsObj, evtTgt);

    if([".benefit-content__content .benefit-content__cta-section .cta-button a.button-primary",
        ".benefit-content__content .benefit-content__cta-section .cta-button a.button-secondary",
        ".benefit-content__content .benefit-content__cta-section .cta-button a.button-secondary-white",
        ".benefit-content__content .benefit-content__cta-section .cta-button-popup-modal a.button-primary",
        ".benefit-content__content .benefit-content__cta-section .cta-button-popup-modal a.button-secondary",
        ".benefit-content__content .benefit-content__cta-section .cta-button-popup-modal a.button-secondary-white",
        ".benefit-content__content .benefit-content__cta-section .cta-button a.button-tertiary",
        ".benefit-content__content .benefit-content__cta-section .cta-button-popup-modal a.button-tertiary",
        ].includes(eventsObj.eventTarget)) return benefitContentAnalytics.getBenefitContentAnalytics(eventsObj, evtTgt);

    return null;
}   